<template>
  <!--@touchstart.stop.prevent="touchStart"-->

  <div class="draggable drag" id="draggable" ref="screenShow" data-class="unableDeactive" @mousedown="mouseDown"
    @touchstart.stop.prevent="touchStart" @touchmove="touchmove" @touchend="touchend"
    :style="{'cursor':spaceShow,'left': mouldId == 7?'-55px':'0','background-color':MapType==1&&MapBgData.bgColor?MapBgData.bgColor:''}">
      <!-- <div class="gridbackground gridbackground-3" ></div> -->
    <div :style="{ ...fatherNonTransform }" class="father_draggable " ref="father_draggable">
      <div class="gridbackground gridbackground-3"  ref="draggableBg" v-if="MapType!=1"></div>
      <!--:disable-scale 保持内部元素不动-->
      <!--调整大小,位移都调用update-->
      <!--调整大小结束,位移结束都调用dragstop
      || (item.id==11&&item.rotateDeg == 0)  添加2d
      -->
      <FreeTransform :id="item.index" :index='item.index' v-for='(item,index) in draggable' v-if="item.ShowActive"
        :ref="item.index" :key="index" :item="item" :actualX="item.x" :actualY="item.y" :x="item.centerPointX"
        :y="item.centerPointY" :scale-x="item.scaleX" :scale-y="item.scaleY" :width="item.fixeWidth"
        :height="item.fixeHeight" :Autowidth="item.width" :Autoheight="item.height" :angle="rotateDegAngle(item)"
        :disable-scale="item.type == 'span' || item.type == 'Divspan' || item.rotateDeg != 0|| (item.id==11&&item.rotateDeg == 0)"
        :selected="item.active" :styles="{zIndex:item.zIndex}" :zIndex="item.zIndex" :class="[{activeDraggable:item.NowActive},item.type]"
        :aspect-ratio="false" :scale-from-center="true" selectOn="mousedown" :BlockArr="item.DeviceBlockArray"
        @click="ChangeClick(item,'Preview')" :dataBlock="dataBlock" :dataName="item.showSpanName"
        :AttrShow='AttrShow?true:item.AttrShow?true:false' :fatherScale="scaleLev" :selfScale="scaleLevel"
        :blockWidth='blockWidth' :blockHeight='blockHeight' :mouldId="mouldId">
        <div class="freebox" :style="{zIndex:item.zIndex}">

          <!--类型为文本标签时-->
          <!--  :class="{'darkSpan':type=='mobile','mobile': type=='mobile'}" -->
          <div class="typeSpan lightSpan" v-if="item.type === 'span'&&regShow(item)">
            <span v-if="item.DevicePropCode!=null && item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">{{spanHTML(item)}}</span>
            <span v-if="item.DevicePropCode==null && item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">请选择关联属性</span>
            <span v-if="!item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">{{item.divName}}</span>
          </div>
         <!-- <div class="typeSpan lightSpan" :class="{'darkSpan':type=='mobile','mobile': type=='mobile'}"
            v-if="item.type === 'span'&&item.attrIdentifier">
            <span v-if="item.type === 'span' && item.DevicePropCode!=null && item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">{{spanHTML(item)}}</span>
            <span v-if="item.type === 'span' && item.DevicePropCode==null && item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">请选择关联属性</span>
            <span v-if="item.type === 'span' && !item.spanShowValue" :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">{{item.divName}}</span>
          </div> -->

          <!--类型为属性看板时-->
          <div class="typeDivSpan lightDivSpan" v-if="item.type === 'Divspan'">
            <span>{{item.divName}}</span>
          </div>

          <!--类型为阀门时-->
          <div :class="{'typeValve':item.type === 'valve','typeWatch':item.type === 'watch'}"
            v-if="item.type === 'valve' || item.type === 'watch'" :style="{'background-image':'url('+item.ImgUrl+')'}">
            <!--<div class="LightShow state0" v-if="item.DeviceStateLightShow&&item.DeviceState==0"></div>
						<div class="LightShow state1" v-if="item.DeviceStateLightShow&&item.DeviceState==1"></div>
						<div class="LightShow state2" v-if="item.DeviceStateLightShow&&item.DeviceState==2"></div>
						<div class="LightShow state3" v-if="item.DeviceStateLightShow&&item.DeviceState==3"></div>-->
          </div>

          <!--类型为仪表时-->
          <!--<div class="typeWatch"  v-if="item.type === 'watch'" :style="{'background-image':'url('+item.ImgUrl+')'}">
						<div class="LightShow state0" v-if="item.DeviceStateLightShow&&item.DeviceState==0"></div>
						<div class="LightShow state1" v-if="item.DeviceStateLightShow&&item.DeviceState==1"></div>
						<div class="LightShow state2" v-if="item.DeviceStateLightShow&&item.DeviceState==2"></div>
						<div class="LightShow state3" v-if="item.DeviceStateLightShow&&item.DeviceState==3"></div>
					</div>-->

          <!--类型为管道时-->
          <div class="backgroundDiv" v-if="item.rotateDeg != 0||item.id == 11">
            <div class="conduit_show"
              :style="item.rotateDeg != 0||item.id == 11 ? backgroundDiv(item.ImgUrl,item.rotateDeg)  : {background:`none`}"></div>

            <div class="rotateDegGit"
              :class="{'XGif': item.direction==1&&item.rotateDeg===-30||item.direction==0&&item.rotateDeg!=-30}">
              <div class="Conduit_gif" :class="{'repeatTop':item.rotateDeg==90}"
                :style="item.thresholdMark?{'background-image': 'url('+item.imageGif+')'}:{'background-image': 'url('+item.imagePng+')'}">
              </div>
            </div>
          </div>

          <!--类型为设备img时-->
          <div class="typeImg" @mouseenter="changeAttrShow(item,1)" @mouseleave="changeAttrShow(item,0)"
            :class="{'MousePointer': item.type=='img'&&(item.DeviceCode != null || item.DeviceCode != undefined)&&item.DeviceState!=4,'UnPointer':item.type=='img'&&(item.DeviceCode != null || item.DeviceCode != undefined)&&item.DeviceState==4}"
            v-if="item.type === 'img'"
            :style="{'background-image':'url('+ImageBaseUrl+item.ImgUrl+')','width':item.width+'px','height':item.height+'px'}">
            <!--报警灯-->
            <div class="AlarmLightShow"
              :style="{'top': item.propertie.alarmLightY+'px','left': item.propertie.alarmLightX+'px'}"
              v-if="item.propertie.hasAlarmLight&&item.DeviceAlertLightShow" :class="AlarmLightShow(item)">
            </div>

            <!--状态灯-->
            <!--<div class="StateLightShow"
							:style="{'top': item.propertie.stateLightY+'px','left': item.propertie.stateLightX+'px'}"
							v-if="item.propertie.hasStateLight&&item.DeviceStateLightShow"
							:class="StateLightShow(item)">
						</div>-->

            <!--进度条-->
            <div class="ProgressBarShow"
              :style="{'top': item.propertie.progressBarY+'px','left': item.propertie.progressBarX+'px'}"
              v-if="item.propertie.hasProgressBar&&item.DeviceProgressLightShow">
              <el-progress :show-text='false' :class="ProgressBarShow(item)" :stroke-width="8"
                :percentage="ProgressBarValue(item)"></el-progress>
            </div>
          </div>

          <!--类型为按钮时-->
          <div class="button" v-if="item.type === 'button'">
            <span>按钮</span>
          </div>

          <!--连接点 + 连接点斜对齐线-->
          <div :style="{'top': itemConnect.y+'px','left': itemConnect.x+'px'}" :x="itemConnect.x" :y="itemConnect.y"
            class="zIndexbottom" v-for="(itemConnect,index) in item.ConnectPoint"
            v-show="item.ConnectMark == true && itemConnect.Mark == true">
            <div class="SkewAlignment" :style="SkewAlingnmentDiv(item.rotateDeg)">
              <div :class="itemSkewAline.name" :style="{'width': itemSkewAline.width+'px'}"
                v-for="(itemSkewAline,index) in itemConnect.SkewAline" v-show="itemSkewAline.Mark == true"></div>
            </div>
          </div>

          <!--斜对齐线-->
          <div class="SkewAlignmentEQ">
            <div v-for="(itemSkewAline,index) in item.SkewAline" :class="itemSkewAline.name"
              v-show="itemSkewAline.Mark == true" :style="{'width': itemSkewAline.width+'px'}"></div>
          </div>

          <!--转接头-->
          <div v-if="item.rotateDeg!=0||item.id == 11">
            <!--近端转接头样式-->
            <div class="zjtClass" :class="NearEndClassFun(item)" v-if="item.id!=10&&item.id!=11"
              :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum,item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl):common.FarEnd(item.rotateDeg,item.FarNum,item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl)"
              v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark"></div>

            <!--<img :class="NearEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum):common.FarEnd(item.rotateDeg,item.FarNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl" />-->

            <!--远端转接头样式-->
            <div class="zjtClass" :class="FarEndClassFun(item)" v-if="item.id!=10&&item.id!=11"
              :style="item.rotateDeg === 30||item.rotateDeg===90?common.FarEnd(item.rotateDeg,item.FarNum,item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl):common.NearEnd(item.rotateDeg,item.NearNum,item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl)"
              v-show="item.rotateDeg===30||item.rotateDeg===90?item.FarEndMark:item.NearEndMark"></div>

            <!--近端转接头样式 2d-->
            <div class="zjtClass" :class="NearEndClassFun(item)" v-if="item.id==10||item.id==11"
              :style="common.NearEnd_2d(item.rotateDeg,item.NearNum,item.NearEndImgUrl)"
              v-show="item.NearEndMark"></div>

            <!--<img :class="NearEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum):common.FarEnd(item.rotateDeg,item.FarNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl" />-->

            <!--远端转接头样式 2d-->
            <div class="zjtClass" :class="FarEndClassFun(item)" v-if="item.id==10||item.id==11"
              :style="common.FarEnd_2d(item.rotateDeg,item.FarNum,item.FarEndImgUrl)"
              v-show="item.FarEndMark"></div>
            <!--<img :class="FarEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.FarEnd(item.rotateDeg,item.FarNum):common.NearEnd(item.rotateDeg,item.NearNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.FarEndMark:item.NearEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl" />-->
          </div>


        </div>
      </FreeTransform>
    </div>

  </div>
</template>
<script>
  import domtoimage from 'dom-to-image'
  import FreeTransform from './FreeTransform.vue'
  import * as Hammer from 'hammerjs'
  import {
    mapState
  } from 'vuex';
  import {
    mapMutations
  } from 'vuex';
  /*引入移动端手势*/
  /*import AlloyFinger from 'alloyfinger'
  import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'*/

  export default {
    components: {
      FreeTransform,
    },
    props: {
      mouldId: {
        type: Number,
        default: -1,
      },
      type: {
        type: String,
        default: "",
      },
      companyIdValue: {
        type: Number,
        default: null
      },
      AttrShow: {
        type: Boolean,
        default: false,
      },
      openMqtt: {
        type: String,
        default: "",
      },
      scaleLev: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        //单指滑动记录坐标
        set:true,
        MapBgData:{},
        MapType:null,
        startX: '',
        startY: '',
        nowLeft: '',
        nowTop: '',
        //展示小地图 缩略图存储
        shotImg: '',

        //alt展示看板的宽度和高度
        blockWidth: 121,
        blockHeight: 125,

        MqttOption: {}, //mqtt主题配置
        MqttByDataSetUrl: [], //需要开启mqtt的url数组(多个) 用于看板mqtt推送
        MqttByLightStateUrl: [], //需要开启mqtt的url数组(多个) 用于所有与设备值相关的mqtt推送
        MqttByAlarmShowUrl: [], //需要开启的mqtt的url数组(多个) 用于报警灯
        //退订时的回调
        MqttExitBackFunction: {
          onSuccess() {
            // console.log("退订成功")
          },
          onFailure(error) {
            // console.log("退订失败")
            // console.log(error)
          }
        },

        draggable: [],

        //判断空格按下
        SpaceMark: false,
        //当前编辑器偏移量
        editorLeft: 0,
        editorTop: 0,
        spaceNum: 0, //当前按下空格第几次
        spaceShow: '', //当前鼠标状态

        //缩放属性
        slider: {
          ValueNum: 100,
        },
        scaleMaxValue: null, //当前可缩放的最大级别 (根据保存时的级别决定)

        attr: 'addrobot',

        //用于展示Alt的看板
        dataBlock: [
          /*{
          					data: [],//存放type==Boolean的属性
          					DeviceCode: 'abc',//关联的设备Code
          				}*/
        ],

        //设备列表
        DeviceList: [],
        VirtualDevice:{},
        //设备属性值数组
        DeviceAttrList: [],

        //所关联的设备属性 类型为int或float或double时 比较符数组
        SymbolIDFoptions: [{
          id: 0,
          name: '>'
        }, {
          id: 1,
          name: '>='
        }, {
          id: 2,
          name: '=='
        }, {
          id: 3,
          name: '<'
        }, {
          id: 4,
          name: '<='
        }, {
          id: 5,
          name: '!='
        }, {
          id: 6,
          name: 'in'
        }, {
          id: 7,
          name: 'between'
        }],

        //所关联的设备属性 类型为enum或bool时 比较符数组
        SymbolEBoptions: [{
          id: 0,
          name: '=='
        }],

      }
    },
    computed: {

      ...mapState("defaultImgOptions", {
        ImageBaseUrl: 'ImageBaseUrl'
      }),

      //tsl物模型
      ProductFeature(){
        return this.$store.state.ProductFeature
      },

      spanHTML() {
        return (item) => {
          let returnData;
          let unit = item.DevicePropUnit ? item.DevicePropUnit : ''
          let properties = this.ProductFeature.filter(itemA => itemA.deviceCode == item.DeviceCode).length != 0 ? this
            .ProductFeature.filter(itemA => itemA.deviceCode == item.DeviceCode)[0].properties : []
          let specs = properties.filter(itemB => itemB.identifier == item.DevicePropCode.split('-')[0]).length != 0 ?
            properties.filter(itemB => itemB.identifier == item.DevicePropCode.split('-')[0])[0].dataType.specs : {};
          let value = specs[item.DevicePropValue] ? specs[item.DevicePropValue] : '';
          if (item.showSpanName) {
            if (item.DevicePropType == 'date' || item.DevicePropType == 'text') {
              returnData = item.DevicePropName + ' : ' + item.DevicePropValue + ' ' + unit;
            } else if (item.DevicePropType == 'enum' || item.DevicePropType == 'bool') {
              returnData = item.DevicePropName + ' : ' + value + ' ' + unit;
            } else {
              returnData = item.DevicePropName + ' : ' + this.common.fmoney(item.DevicePropValue) + ' ' + unit;
            }
          } else {
            if (item.DevicePropType == 'date' || item.DevicePropType == 'text') {
              returnData = item.DevicePropValue + ' ' + unit
            } else if (item.DevicePropType == 'enum' || item.DevicePropType == 'bool') {
              returnData = value + ' ' + unit;
            } else {
              returnData = this.common.fmoney(item.DevicePropValue) + ' ' + unit
            }
          }
          if (item.DevicePropValue==0 || item.DevicePropValue) {
            return returnData;
          } else {
            return ''
          }
        }
      },
      regShow(){
        return(item)=>{
          if(!item.attrIdentifier){
            return true
          }else{
            for(let obj of this.DeviceAttrList){
              if(obj.deviceId == item.textShowData[0]){
                let val = obj.attrValList.filter(attr => attr.code == item.attrIdentifier)
                if(val.length>0&&Number(val[0].value)==Number(item.showAttrKey)){
                   return true
                }else{
                   return false
                }
              }
            }
          }
        }
      },
      SliderValue() {
        return this.slider.ValueNum;
      },
      scaleLevel() { //缩放等级:0.3-1
        return this.$store.getters['defaultImgOptions/getScaleLevel'];
      },
      fatherNonTransform() {
        return {
          transform: `scale(${this.scaleLevel})`,
          left: this.editorLeft * this.scaleLevel + 'px',
          top: this.editorTop * this.scaleLevel + 'px'
        };
      },

      fatherNonTransform3() {
        return {
          transform: `scale(${this.scaleLevel})`,
        };
      },
      fatherNonTransform2() {
        return {
          transform: `scale(${this.scaleLevel+0.375})`,
          left: this.editorLeft * this.scaleLevel + 'px',
          top: this.editorTop * this.scaleLevel + 'px'
        };
      },
      nonTransform() {
        return {
          transform: `scale(${1 / this.scaleLevel})`
        };
      },
      ConnectPointStyle() {
        return {
          top: `${this.scaleLevel}`
        };
      },
      nonTransformTwo() {
        return {
          transform: `scale(${1 / this.scaleLevel}) translateX(-100%)`
        }
      },
      companyId() {
        return this.$store.state.companyId
      },
      /*报警灯颜色类名Change*/
      AlarmLightShow() {
        return (item) => {
          let ret;
          if (item.offline_MARK) {
            if (item.offline == 1) {
              ret = 'AlarmLightShow-1'
            } else {
              ret = item.DeviceAlertLight_state || item.DeviceAlertLight_state == 0 ? 'AlarmLightShow' + item
                .DeviceAlertLight_state : 'AlarmLightShow'
            }
          } else {
            ret = item.DeviceAlertLight_state || item.DeviceAlertLight_state == 0 ? 'AlarmLightShow' + item
              .DeviceAlertLight_state : 'AlarmLightShow'
          }
          return ret;
        }
      },
      /*状态指示灯颜色类名Change*/
      StateLightShow() {
        return (item) => {
          return item.DeviceStateLight_state ? 'StateLightShow' + item.DeviceStateLight_state : 'StateLightShow'
        }
      },
      /*进度条颜色类名Change*/
      ProgressBarShow() {
        return (item) => {
          let returnString;
          if (item.DeviceProgress_state == 1) {
            /*蓝色*/
            returnString = 'blueBystate'
          } else if (item.DeviceProgress_state == 2) {
            /*黄色*/
            returnString = 'yellowBystate'
          } else if (item.DeviceProgress_state == 3) {
            /*红色*/
            returnString = 'redBystate'
          }
          if (item.DeviceProgressEffect == 'top') {
            returnString += ' ProgressTop'
          } else if (item.DeviceProgressEffect == 'bottom') {
            returnString += ' ProgressBottom'
          } else {
            returnString += ' ProgressUnset'
          }
          return returnString;
        }
      },
      /*进度条百分比更新*/
      ProgressBarValue() {
        return (item) => {
          return item.DeviceProgressValue
        }
      },
    },
    created() {
      if (this.type == 'index') {
        this.$parent.ChangeHeaderShow('hide');
      }
    },
    updated() {

    },
    mounted() {
      var self = this;
      /*初始化地图*/
      this.initMap();

      /*绑定滚轮事件*/
      if (this.type != 'mobile') {
        document.getElementById('draggable').addEventListener('mousewheel', self.handleScroll, false)
      }
      /*按下*/
      window.addEventListener('keydown', ev => {
        ev = ev || event;
        //空格按下
        if (ev.keyCode == 32) {
          if (self.scaleLevel > self.scaleMaxValue) {
            self.SpaceMark = true;
            if (self.spaceNum == 0) {
              self.spaceShow = 'grab' //切换当前手指状态
            }
            self.spaceNum++;
          }
        }
      })
      /*松开*/
      window.addEventListener('keyup', ev => {
        ev = ev || event;
        //空格松开
        if (ev.keyCode == 32) {
          if (self.scaleLevel > self.scaleMaxValue) {
            self.SpaceMark = false;
            self.spaceNum = 0;
            self.spaceShow = '' //切换当前手指状态
          }
        }
      });

      /*开启移动端缩放*/
      // if (this.type == 'mobile') {
      //   let hamm = Hammer(document.getElementById('draggable'))
      //   hamm.get('pinch').set({
      //     enable: true
      //   });
      //   hamm.on("pinch", function(ev) {
      //     self.hammerPinch(ev);
      //   })
      // }
    },
    methods: {
      /*移动端缩放*/
      hammerPinch(eObj) {
        //console.log(eObj)
        let scale = eObj.scale.toFixed(2);
        let newScale = (this.scaleLevel * scale) * 100;
        if (newScale < (this.scaleMaxValue * 100 * 5) && newScale > (this.scaleMaxValue * 100)) {
          this.slider.ValueNum = newScale;
        }
        // console.log(eObj, newScale, this.slider.ValueNum)
        this.$forceUpdate()
      },

      /*鼠标移入时 切换当前看板状态*/
      async changeAttrShow(item, type) {
        /*
         * item => 当前控件
         * type为1时 展开看板, type为0时 关闭看板
         * 当按住Alt时 直接return
         */
        if (this.AttrShow) return;

        if (item.type == 'img' && this.common.istrue(item.DeviceCode) && item.DeviceName != "虚拟设备") {
          if (type == 1) {
            this.draggable.filter(i => i.index == item.index)[0].AttrShow = true
          } else {
            this.draggable.filter(i => i.index == item.index)[0].AttrShow = false
          }
          /*this.draggable.filter(i => i.index == item.index)[0].AttrShow = !this.draggable.filter(i => i.index == item.index)[0].AttrShow;*/
          /*if(this.draggable.filter(i => i.index == item.index)[0].AttrShow){
          	await this.UpdateDataBlock();
          	for(let obj of this.dataBlock){
          		let url = 'sys/device/' + obj.code + '/property/push'
          		if(this.MqttByDataSetUrl.filter(item => item == url).length == 0){
          			this.$store.state.nazeki.subscribe(url, { qos: 1 })
          			this.MqttByDataSetUrl.push(url)
          		}
          	}
          }else{
          	for(let url of this.MqttByDataSetUrl){
          		this.$store.state.nazeki.unsubscribe(url,this.MqttExitBackFunction)
          	}
          	this.MqttByDataSetUrl = [];
          }*/
          this.$forceUpdate()
        }
      },

      /*初始化地图*/
      initMap() {
        let self = this;
        this.$getItem('draggablePreview').then((value) => {
          //console.log(value);
          if (value && this.type == 'map') {
            /*通过编辑器中的预览显示*/
            this.upDateDraggable(value.filter(item => item.ShowActive == true));
            this.scaleLevelModify(JSON.parse(sessionStorage.getItem('draggableScaleLevel')));
            sessionStorage.setItem('scaleLevel', this.scaleLevel)

            this.slider.ValueNum = this.scaleLevel * 100;
            this.scaleMaxValue = this.scaleLevel
            /*进入页面时调用获取属性值*/
            this.getData();
            this.LightConnectMqtt();
          } else {
            /*不从编辑器中的预览进入时*/
            let companyId;
            if (this.companyIdValue != null) {
              companyId = this.companyIdValue;
            } else {
              companyId = this.companyId;
            }
            // if (this.type == 'mobile') {
            //   /*微信端 获取最新设备地图*/
            //   this.getMapDataByWx(companyId);
            // } else {
            //   /*PC端 获取最新设备地图*/
            // }

            this.getMapDataByPc(companyId);
          }
        }).catch((err) => {
          // console.log(err);
        });
      },

      /*Wx 获取地图*/
      // getMapDataByWx(companyId) {
      //   this.wx_get('/DeviceMap/getCurrent', {
      //     companyId: companyId
      //   }).then((res) => {
      //     if (res.success == true) {
      //       if (JSON.stringify(res.result) == "{}") return;
      //       this.scaleLevelModify(JSON.parse(res.result.content).scaleLevel)
      //       this.updateBgScale(JSON.parse(res.result.content).scaleLevel)
      //       this.upDateDraggable(JSON.parse(res.result.content).draggable)
      //       this.MapBgData=JSON.parse(res.result.content).MapBgData
      //       this.MapType=JSON.parse(res.result.content).mapType
      //       sessionStorage.setItem('scaleLevel', this.scaleLevel)
      //       this.slider.ValueNum = this.scaleLevel * 100;
      //       this.scaleMaxValue = this.scaleLevel
      //       /*进入页面时调用获取属性值*/
      //       this.getData('wx');
      //       this.LightConnectMqtt();
      //     }
      //   })
      // },

      /*PC 获取地图*/
      getMapDataByPc(companyId) {
        let self = this;
        this.get('/DeviceMap/getCurrent', {
          companyId: companyId
        }).then((res) => {
          if (res.success == true) {
            if (JSON.stringify(res.result) == "{}") return;
            self.scaleLevelModify(JSON.parse(res.result.content).scaleLevel)
            // console.log(JSON.parse(res.result.content).scaleLevel)
            this.updateBgScale(JSON.parse(res.result.content).scaleLevel)
            this.upDateDraggable(JSON.parse(res.result.content).draggable)
            sessionStorage.setItem('scaleLevel', this.scaleLevel)
            this.MapBgData=JSON.parse(res.result.content).MapBgData
            this.MapType=JSON.parse(res.result.content).mapType
            this.slider.ValueNum = this.scaleLevel * 100;
            this.scaleMaxValue = this.scaleLevel
            this.getData();
            /*进入页面时调用获取属性值*/
            this.LightConnectMqtt();
          }
        })
      },
      // 更新背景地板
      updateBgScale(i){
        // console.log(i)
        let v;
        if(i == 1){
          v=0.88
        }else if(i == 0.625){
          v=1.4
        }else if(i == 0.5){
          v=1.75
        }else if(i == 0.3125){
          v=2.85
        }else if(i == 0.25){
          v=3.55
        }
        this.$refs.draggableBg.style.transform = 'scale(' + v+ ')';
      },
      /*视角重置*/
      editorClear() {
        this.editorLeft = 0
        this.editorTop = 0
      },
      editorLeftUpdate(val) {
        this.editorLeft = val
      },
      editorTopUpdate(val) {
        this.editorTop = val
      },
      /*获取设备地图 更新*/
      upDateDraggable(arr) {
        for (let ThisActive of arr) {
          if (ThisActive.colorId == 1) {
            if (ThisActive.rotateDeg == 90) {
              ThisActive.imagePng = require('@/assets/image/editor/gray_top_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/gray_top_gif.gif')
            } else {
              ThisActive.imagePng = require('@/assets/image/editor/gray_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/gray_gif.gif')
            }
          } else if (ThisActive.colorId == 2) {
            if (ThisActive.rotateDeg == 90) {
              ThisActive.imagePng = require('@/assets/image/editor/red_top_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/red_top_gif.gif')
            } else {
              ThisActive.imagePng = require('@/assets/image/editor/red_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/red_gif.gif')
            }
          } else if (ThisActive.colorId == 3) {
            if (ThisActive.rotateDeg == 90) {
              ThisActive.imagePng = require('@/assets/image/editor/blue_top_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/blue_top_gif.gif')
            } else {
              ThisActive.imagePng = require('@/assets/image/editor/blue_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/blue_gif.gif')
            }
          } else if (ThisActive.colorId == 4) {
            if (ThisActive.rotateDeg == 90) {
              ThisActive.imagePng = require('@/assets/image/editor/green_top_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/green_top_gif.gif')
            } else {
              ThisActive.imagePng = require('@/assets/image/editor/green_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/green_gif.gif')
            }
          } else if (ThisActive.colorId == 5) {
            if (ThisActive.rotateDeg == 90) {
              ThisActive.imagePng = require('@/assets/image/editor/org_top_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/org_top_gif.gif')
            } else {
              ThisActive.imagePng = require('@/assets/image/editor/org_png.png')
              ThisActive.imageGif = require('@/assets/image/editor/org_gif.gif')
            }
          }
        }
        this.draggable = arr.sort(function(a,b){return a.type=="span"?-1:1});
      },

      /*获取当前设备状态*/
      getDeviceState(code) {
        /* 同步
         * 传入设备code编码
         * 返回当前设备状态值Number型
         */
        let self = this;
        return new Promise((resolve) => {
          let FeatureArr = self.DeviceList.filter(item => item.code == code)
          if (FeatureArr.length == 0) {
            // self.get('/Device/getByCode', {
            //   code: code, //设备code
            // }).then((resPro) => {
            //   if (resPro.success == true) {
            //     let result = resPro.result;
            //     self.DeviceList.push(result)
            //     resolve(Number(result.state))
            //     return;
            //   }
            // })
            resolve(3)
          } else {
            resolve(Number(FeatureArr[0].state))
          }
        })
      },

      /*获取属性值 在第一次进入时调用*/
      async getData() {
        await this.getDeviceList();
        let getAttrArr = this.draggable.filter(dragItem => this.common.istrue(dragItem.DeviceCode))
        await this.getFeatureList(getAttrArr)
        await this.getDeviceAttrValueByArr(getAttrArr);
        if (this.openMqtt == '1') {
          this.connectMqtt();
        }
      },

      initValue(value, type, step) {
        let self = this;
        /*featureList.dataType.type == 'int' ? self.common.fmoney(Math.floor(Number(value))) : featureList.dataType.type == 'enum' || featureList.dataType.type == 'bool' ? Number(value) : self.common.fmoney(Number(value),featureList.dataType.specs.step)*/
        let returnValue;
        if (!value&&value!=0){
          // console.log('null',value,type, step)
          return null
        }
        if (type == 'int') {
          returnValue = self.common.fmoney(Math.floor(Number(value)));
        } else if (type == 'enum' || type == 'bool') {
          returnValue = Number(value)
        } else if (type == 'date') {
          returnValue = self.changeTimeY(Number(value))
        } else if (type == 'text') {
          returnValue = value
        } else {
          returnValue = self.common.fmoney(Number(value), step)
        }
        return returnValue

      },

      /*微信端 通过 设备id 获取设备属性值对象*/
      // wx_getDeviceAttrValue(deviceId, deviceCode, deviceName) {
      //   /* 同步
      //    * deviceId => 设备id
      //    * deviceCode => 设备Code (用于辨识是否为虚拟设备 调用不同接口)
      //    * 返回设备属性值对象
      //    * */
      //   let self = this;
      //   return new Promise((resolve) => {
      //     let DeviceArr = self.DeviceAttrList.filter(item => item.deviceCode == deviceCode)
      //     if (DeviceArr.length == 0) {
      //       if (deviceName == '虚拟设备') {
      //         self.wx_get('/VirtualDevice/getPropertyValue', {
      //           deviceId: deviceId, //虚拟设备id
      //         }).then((resPro) => {
      //           if (resPro.success == true) {
      //             let dataList = resPro.result;
      //             self.DeviceAttrList.push({
      //               deviceId:deviceId,
      //               deviceCode: deviceCode,
      //               attrValList: dataList
      //             })
      //             resolve(dataList)
      //             return;
      //           } else {
      //             resolve([])
      //             return;
      //           }
      //         })
      //       } else {
      //         self.wx_get('/Device/getPropertyValue', {
      //           deviceId: deviceId, //设备id
      //         }).then((resPro) => {
      //           if (resPro.success == true) {
      //             let dataList = resPro.result;
      //             self.DeviceAttrList.push({
      //               deviceId:deviceId,
      //               deviceCode: deviceCode,
      //               attrValList: dataList
      //             })
      //             resolve(dataList)
      //             return;
      //           } else {
      //             resolve([])
      //             return;
      //           }
      //         })
      //       }

      //     } else {
      //       resolve(DeviceArr[0].attrValList)
      //       return;
      //     }
      //   })
      // },

      // 批量获取tsl
      getFeatureList(deviceDataArr){
      	let codeArr=[],self=this
      	for(let d of deviceDataArr){
      	  let code=d.DeviceCode
      	  if(code == this.VirtualDevice.id){
      		code = this.VirtualDevice.code
      	  }
      	  if(!codeArr.includes(code)&&self.DeviceList.filter(item=>item.code==code).length!=0){
            codeArr.push(code)
      	  }
      	}
      	let companyId;
      	if (this.companyIdValue != null) {
      	  companyId = this.companyIdValue;
      	} else {
      	  companyId = this.companyId;
      	}
      	let p={
      	  companyId:companyId,
      	  codes:codeArr.toString()
      	}
      	this.get('/ProductFeature/getMultiByDeviceCode',p).then(res=>{
      	  if(res.success){
      	    for(let item of res.result){
              if(item.tsl){
                self.ProductFeature.push({
                  deviceCode: item.deviceCode,
                  properties: JSON.parse(item.tsl).properties
                })
              }
      	    }
      	  }
      	})
      },

      // 批量获取设备属性值对象
      getDeviceAttrValueByArr(deviceDataArr){
        let codeArr=[],dataArr=[],self=this
        for(let d of deviceDataArr){
          let code=d.DeviceCode
          if(code == this.VirtualDevice.id){
            code = this.VirtualDevice.code
          }
          if(!codeArr.includes(code)&&self.DeviceList.filter(item=>item.code==code).length!=0){
            codeArr.push(code)
          }
          let obj = {
            deviceId:d.DeviceId,
            deviceCode:d.DeviceCode
          }
          dataArr.push(obj)
        }
        let companyId;
        if (this.companyIdValue != null) {
          companyId = this.companyIdValue;
        } else {
          companyId = this.companyId;
        }
        let p={
          companyId:companyId,
          deviceCodes:codeArr.toString()
        }
        this.get('/Device/getMultiPropertyValue',p).then(res=>{
          if(res.success){
            for(let item of res.result){
              for(let dev of dataArr){
                // 判断是不是虚拟设备
                if(item.deviceCode==this.VirtualDevice.code&&dev.deviceCode==this.VirtualDevice.id){
                  dev.attrValList = item.properties
                }else if(item.deviceCode == dev.deviceCode){
                  dev.attrValList = item.properties
                }
              }
            }
            this.DeviceAttrList = dataArr
          }
        }).then(async ()=>{
          for (let item of deviceDataArr) {
            //					if(this.common.istrue(item.DeviceCode) && item.DeviceName != '虚拟设备'){
            /*获取设备当前状态*/
            item.DeviceState = self.getDeviceState(item.DeviceCode);
            // let attrValList;
            // if (this.type == 'mobile') {
            //   attrValList = await self.wx_getDeviceAttrValue(item.DeviceId, item.DeviceCode, item.DeviceName)
            // } else {
            //   attrValList = await self.getDeviceAttrValue(item.DeviceId, item.DeviceCode, item.DeviceName)
            // }
            let attrValList = await self.getDeviceAttrValue(item.DeviceId, item.DeviceCode, item.DeviceName)
            let items = {};
            for (let a of attrValList) {
              items[a.code] = a.value;
            }

            // 关联设备与显示属性所关联的设备不同时需要获取显示显示属性的值
            if(item.textShowData&& item.textShowData[0]!=item.DeviceId){
              // if (this.type == 'mobile') {
              //   self.wx_getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
              // } else {
              //   self.getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
              // }
              self.getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
            }
            /*报警提示灯更新*/
            if (item.propertie && item.propertie.hasAlarmLight && item.DeviceAlertLightShow) {
              /*判断这个设备优先级最高的属性offline是否存在*/
              if (items.offline || (items.offline == 0)) {
                item.offline_MARK = true
                item.offline = items.offline;
                if (!items.offline) {
                  //在线情况下
                  item.DeviceAlertLight_state = 0; //默认是0 即离线
                  /*报警提示灯更新*/
                  if (this.common.istrue(items[item.DeviceAttrStateID])) {
                    if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                      item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID])
                    }
                  }
                } else {
                  //离线情况下
                  item.DeviceAlertLight_state = 0;
                  if (this.common.istrue(items[item.DeviceAttrStateID])) {
                    if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                      item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID])
                    }
                  }
                }
              } else {
                item.offline_MARK = false
                item.DeviceAlertLight_state = 0; //默认是0 即离线
                /*报警提示灯更新*/
                if (this.common.istrue(items[item.DeviceAttrStateID])) {
                  if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                    item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID])
                  }
                }
              }
            }

            /*进度条更新*/
            if (items[item.DeviceAttrID]) {
              if (item.propertie && item.propertie.hasProgressBar && item.DeviceProgressLightShow) {
                let featureList = await self.getProductFeature(item.DeviceCode, item.DeviceAttrID),
                  value = Number(items[item.DeviceAttrID]), //mqtt推送的属性值
                  min = Number(featureList.dataType.specs.min), //属性值的最大值
                  max = Number(featureList.dataType.specs.max), //属性值的最小值
                  errorDown = Number(featureList.dataType.errorDown), //属性值下限
                  errorUp = Number(featureList.dataType.errorUp), //属性值上限
                  warnDown = Number(featureList.dataType.warnDown), //属性值下下限
                  warnUp = Number(featureList.dataType.warnUp); //属性值上上限
                let state = 1;
                if (errorUp) {
                  if (value > errorUp) {
                    state = 2;
                  }
                }
                if (errorDown) {
                  if (value < errorDown) {
                    state = 2;
                  }
                }
                if (warnUp) {
                  if (value > warnUp) {
                    state = 3;
                  }
                }
                if (warnDown) {
                  if (value < warnDown) {
                    state = 3;
                  }
                }
                item.DeviceProgressValue = (((value - min) / (max - min)).toFixed(2)) * 100;
                item.DeviceProgress_state = state;
              }
            }

            /*管道更新*/
            if (item.DevicePropCode && (this.common.istrue(items[item.DevicePropCode.split('-')[0]])||this.common.istrue(items[item.DevicePropCode.split('-')[0]])==0)) {
              if (this.common.istrue(item.DevicePropCode)) {
                // let feature = await self.getProductFeature(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                let feature;
                if(item.DeviceName!='虚拟设备'){
                  feature = await self.getProductFeature(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                }else{
                  feature = await self.getVirtualDevicePro(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                  feature.dataType = {}
                }
                if (item.rotateDeg != 0||item.id == 11) {
                  /*管道*/
                  let value = Number(items[item.DevicePropCode.split('-')[0]])
                  let itemValue = Number(item.thresholdValue)
                  if (feature.dataType.type == 'bool' || feature.dataType.type == 'enum') {
                    if (item.thresholdSymbol == 0) {
                      if (Number(item.thresholdValue) == value) {
                        item.thresholdMark = true;
                      }
                    }
                  } else {
                    if (item.thresholdSymbol == 0) {
                      // >
                      if (value > itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 1) {
                      // >=
                      if (value >= itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 2) {
                      // ==
                      if (value == itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 3) {
                      // <
                      if (value < itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 4) {
                      // <=
                      if (value <= itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 5) {
                      // !=
                      if (value != itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 6) {
                      //in
                      let arr = JSON.parse(item.thresholdValue);
                      if (arr.filter(item => Number(item) == value).length != 0) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 7) {
                      //between
                      let arr = JSON.parse(item.thresholdValue);
                      if (Number(value) > Number(arr[0]) && Number(value) < Number(arr[1])) {
                        item.thresholdMark = true;
                      }
                    }
                  }
                }else if (item.type == 'span') {
                   if(item.DeviceName != '虚拟设备'){
                     /*文本标签*/
                     item.DevicePropName = feature.name;
                     item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], feature.dataType.type,
                       feature.dataType.specs.step);
                     item.DevicePropType = feature.dataType.type;
                     item.DevicePropUnit = feature.dataType.specs.unit;
                   }else{
                     /*文本标签*/
                     item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], '', feature.step);
                   }
                }
              }
            }
          }
          // 文本标签更新
          // for(let item of spanArr){
          //   item.DeviceState = await self.getDeviceState(item.DeviceCode);
          //   /*获取文本标签属性值*/
          //   let attrValList = await self.getDeviceAttrValue(item.DeviceId, item.DeviceCode, item.DeviceName)
          //   let items = {};
          //   for (let a of attrValList) {
          //     items[a.code] = a.value;
          //   }
          //   if (item.DevicePropCode && (this.common.istrue(items[item.DevicePropCode.split('-')[0]])||this.common.istrue(items[item.DevicePropCode.split('-')[0]])==0)) {
          //     /*获取设备当前状态*/
          //     let feature;
          //     if(item.DeviceName!='虚拟设备'){
          //       feature = await self.getProductFeature(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
          //     }else{
          //       feature = await self.getVirtualDevicePro(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
          //       feature.dataType = {}
          //     }
          //     // 关联显示属性不一致时获取显示属性
          //     if(item.textShowData&& item.textShowData[0]!=item.DeviceId){
          //       // if (this.type == 'mobile') {
          //       //   self.wx_getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
          //       // } else {
          //       //   self.getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
          //       // }
          //       self.getDeviceAttrValue(item.textShowData[0], item.DeviceShowCode,'')
          //     }

          //     if(item.DeviceName != '虚拟设备'){
          //       /*文本标签*/
          //       item.DevicePropName = feature.name;
          //       item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], feature.dataType.type,
          //         feature.dataType.specs.step);
          //       item.DevicePropType = feature.dataType.type;
          //       item.DevicePropUnit = feature.dataType.specs.unit;
          //     }else{
          //       /*文本标签*/
          //       item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], '', feature.step);
          //     }
          //   }
          // }
          this.$forceUpdate()
        })
      },

      /*通过 设备id 获取设备属性值对象*/
      getDeviceAttrValue(deviceId, deviceCode, deviceName) {
        /* 同步
         * deviceId => 设备id
         * deviceCode => 设备Code (用于辨识是否为虚拟设备 调用不同接口)
         * 返回设备属性值对象
         * */
        let self = this;
        return new Promise((resolve) => {
          let DeviceArr = self.DeviceAttrList.filter(item => item.deviceCode == deviceCode)
          if (DeviceArr.length == 0) {
            if(this.DeviceList.filter(item => item.code==deviceCode).length==0){
              return
              resolve([])
            }
            if (deviceName == '虚拟设备') {
              self.get('/VirtualDevice/getPropertyValue', {
                deviceId: deviceId, //虚拟设备id
              }).then((resPro) => {
                if (resPro.success == true) {
                  let dataList = resPro.result;
                  self.DeviceAttrList.push({
                    deviceId:deviceId,
                    deviceCode: deviceCode,
                    attrValList: dataList
                  })
                  resolve(dataList)
                  return;
                } else {
                  resolve([])
                  return;
                }
              })
            } else {
              console.log('get:',deviceCode)
              self.get('/Device/getPropertyValue', {
                deviceId: deviceId, //设备id
              }).then((resPro) => {
                if (resPro.success == true) {
                  let dataList = resPro.result;
                  self.DeviceAttrList.push({
                    deviceId:deviceId,
                    deviceCode: deviceCode,
                    attrValList: dataList
                  })
                  resolve(dataList)
                  return;
                } else {
                  resolve([])
                  return;
                }
              })
            }

          } else {
            resolve(DeviceArr[0].attrValList)
            return;
          }
        })
      },

      // 获取虚拟设备属性
      getVirtualDevicePro(id,propertyCode){
        return new Promise((resolve) => {
          if(!id&&id!=0){ return }
            this.get('/VirtualDevice/getPropertyList', {
              deviceId: id, //虚拟设备id
            }).then((resPro) => {
              if (resPro.success == true) {
                let dataList = resPro.result
                resolve(dataList.filter(item => item.code == propertyCode)[0])
                return;
              }
            })
        })
   //        if (this.type == 'mobile') {
			// if(!id&&id!=0){ return }
   //          this.wx_get('/VirtualDevice/getPropertyList', {
   //            deviceId: id, //虚拟设备id
   //          }).then((resPro) => {
   //            if (resPro.success == true) {
   //              let dataList = resPro.result;
   //              resolve(dataList.filter(item => item.code == propertyCode)[0])
   //              return;
   //            }
   //          })
   //        } else {
			// if(!id&&id!=0){ return }
   //          this.get('/VirtualDevice/getPropertyList', {
   //            deviceId: id, //虚拟设备id
   //          }).then((resPro) => {
   //            if (resPro.success == true) {
   //              let dataList = resPro.result
   //              resolve(dataList.filter(item => item.code == propertyCode)[0])
   //              return;
   //            }
   //          })
   //        }
   //      })
      },
      /*通过 设备Code/属性code 获取物模型对象*/
      getProductFeature(deviceCode, propertyCode) {
        /* 同步
         * deviceCode => 设备code
         * propertyCode => 属性code
         * 返回物模型对象
         * 如果属性Code存在 则返回属性Code对应的物模型属性对象
         * */
        let self = this;
        return new Promise((resolve) => {
          let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
          if (FeatureArr.length == 0) {
            // if (this.type == 'mobile') {
            //   self.wx_get('/ProductFeature/getByDeviceCode', {
            //     code: deviceCode, //设备code
            //   }).then((resPro) => {
            //     if (resPro.success == true) {
            //       let dataList = JSON.parse(resPro.result).properties;
            //       self.ProductFeature.push({
            //         deviceCode: deviceCode,
            //         properties: dataList
            //       })
            //       if (propertyCode) {
            //         resolve(dataList.filter(item => item.identifier == propertyCode)[0])
            //       } else {
            //         resolve(dataList)
            //       }
            //       return;
            //     }
            //   })
            // } else {
            //   // console.log('get2',deviceCode)
            //   self.get('/ProductFeature/getByDeviceCode', {
            //     code: deviceCode, //设备code
            //   }).then((resPro) => {
            //     if (resPro.success == true) {
            //       let dataList = JSON.parse(resPro.result).properties;
            //       self.ProductFeature.push({
            //         deviceCode: deviceCode,
            //         properties: dataList
            //       })
            //       if (propertyCode) {
            //         resolve(dataList.filter(item => item.identifier == propertyCode)[0])
            //       } else {
            //         resolve(dataList)
            //       }
            //       return;
            //     }
            //   })
            // }

            if(this.DeviceList.filter(item => item.code==deviceCode).length==0){
              return
              resolve({dataType:{specs:{}}})
            }
            self.get('/ProductFeature/getByDeviceCode', {
              code: deviceCode, //设备code
            }).then((resPro) => {
              if (resPro.success == true) {
                let dataList = JSON.parse(resPro.result).properties;
                self.ProductFeature.push({
                  deviceCode: deviceCode,
                  properties: dataList
                })
                if (propertyCode) {
                  resolve(dataList.filter(item => item.identifier == propertyCode)[0])
                } else {
                  resolve(dataList)
                }
                return;
              }
            })
          } else {
            if (propertyCode) {
              resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
            } else {
              resolve(FeatureArr[0].properties)
            }
            return;
          }
        })
      },

      /*进入页面 连接mqtt 获取所有控件所绑定的*/
      LightConnectMqtt() {
        let self = this;
        // mqtt连接
        this.MqttOption = {
          //clientId: this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_LightByEditor',
          connectTimeout: 600000,
          clean: true
        }
        // if (this.type == 'mobile') {
        //   this.MqttOption = 'wx' + this.$store.state.userData.code + '_' + this.$store.state.companyCode +
        //     '_LightByEditor'
        // } else {
        //   this.MqttOption = this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_LightByEditor'
        // }
        this.MqttOption.clientId = this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_LightByEditor'
        this.$store.state.buerga = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.MqttOption)

        for (let obj of this.draggable) {
          if (this.common.istrue(obj.DeviceCode)) {
            let url;
            let urlTwo;
            if (obj.DeviceName == '虚拟设备') {
              url = 'sys/virtual/' + obj.DeviceCode + '/property/push'
            } else {
              url = 'sys/device/' + obj.DeviceCode + '/property/push'
            }
            urlTwo = `sys/device/${obj.DeviceCode}/status/push`

            if (this.MqttByLightStateUrl.filter(item => item == url).length == 0) {
              this.$store.state.buerga.subscribe(url, {
                qos: 1
              })
              this.MqttByLightStateUrl.push(url)
            }

            if (self.MqttByAlarmShowUrl.filter(item => item == urlTwo).length == 0) {
              self.$store.state.buerga.subscribe(urlTwo, {
                qos: 1
              })
              self.MqttByAlarmShowUrl.push(urlTwo)
            }
          }
        }

        this.getMqttLightMessage();
      },

      /*如果是从首页编辑展示进入 则连接mqtt*/
      async connectMqtt() {
        //更新dataBlock,将需要Alt展示看板的控件push进dataBlock
        await this.UpdateDataBlock();
        // mqtt连接
        /*this.MqttOption = {
        	clientId: this.$store.state.userData.code + '_' + this.$store.state.companyCode + '_IndexEditShow_editor',
        	connectTimeout: 600000,
        	clean: true
        }
        this.$store.state.nazeki = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.MqttOption)
        for(let obj of this.dataBlock){
        	let url = 'sys/device/' + obj.code + '/property/push'
        	if(this.MqttByDataSetUrl.filter(item => item == url).length == 0){
        		this.$store.state.nazeki.subscribe(url, { qos: 1 })
        		this.MqttByDataSetUrl.push(url)
        	}
        }*/

        //this.getMqttMessage();
      },

      async mqttUpdateFunction(topic, message) {
        let self = this;
        let data = JSON.parse(message.toString());
        let items = data.items;

        /*在此更新Alt看板属性*/
        if (this.openMqtt == '1' && topic.indexOf('/property/push') != -1) {
          this.mqttBynzkUpdata(topic, message)
        }

        /*更新indexEditShow中的系统运行状态*/
        if (topic.indexOf('/property/push') != -1&&this.$parent.$parent.updataSystemState) {
          this.$parent.$parent.updataSystemState(message);
        }

        for (let item of this.draggable.filter(dragItem => dragItem.DeviceCode == data.deviceCode)) {
          if (topic.indexOf('/property/push') != -1) {
            /*判断开关机关联属性状态*/
            /*if(item.propertie&&item.propertie.hasAlarmLight&&item.DeviceAlertLightShow){
            	// 上方已先判断mqtt的报警灯状态(颜色)值 再判断开关机关联的属性(布尔值)是离线还是在线(等级最高)
            	if(this.common.istrue(items[item.DeviceAttrStateID])){
            		item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID]);
            	}
            }*/

            /*判断报警灯关联属性状态*/
            if (item.propertie && item.propertie.hasAlarmLight && item.DeviceAlertLightShow) {
              if (item.offline_MARK) {
                if (items.offline || (items.offline == 0)) {
                  item.offline = items.offline;
                  if (this.common.istrue(items[item.DeviceAttrStateID]) || items[item.DeviceAttrStateID] == 0) {
                    if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                      item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID]);
                    }
                  }
                } else {
                  if (this.common.istrue(items[item.DeviceAttrStateID]) || items[item.DeviceAttrStateID] == 0) {
                    if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                      item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID]);
                    }
                  }
                }
              } else {
                if (this.common.istrue(items[item.DeviceAttrStateID]) || items[item.DeviceAttrStateID] == 0) {
                  if (item.DeviceAlertLight_state != 2 && item.DeviceAlertLight_state != 3) {
                    item.DeviceAlertLight_state = Number(items[item.DeviceAttrStateID]);
                  }
                }
              }
            }

            /*进度条更新*/
            if (items[item.DeviceAttrID]) {
              if (item.propertie && item.propertie.hasProgressBar && item.DeviceProgressLightShow) {
                let featureList = await self.getProductFeature(item.DeviceCode, item.DeviceAttrID),
                  value = Number(items[item.DeviceAttrID]), //mqtt推送的属性值
                  min = Number(featureList.dataType.specs.min), //属性值的最大值
                  max = Number(featureList.dataType.specs.max), //属性值的最小值
                  errorDown = Number(featureList.dataType.errorDown), //属性值下限
                  errorUp = Number(featureList.dataType.errorUp), //属性值上限
                  warnDown = Number(featureList.dataType.warnDown), //属性值下下限
                  warnUp = Number(featureList.dataType.warnUp); //属性值上上限
                let state = 1;
                if (errorUp) {
                  if (value > errorUp) {
                    state = 2;
                  }
                }
                if (errorDown) {
                  if (value < errorDown) {
                    state = 2;
                  }
                }
                if (warnUp) {
                  if (value > warnUp) {
                    state = 3;
                  }
                }
                if (warnDown) {
                  if (value < warnDown) {
                    state = 3;
                  }
                }
                if (item.DeviceProgressValue < (((value - min) / (max - min)).toFixed(2)) * 100) {
                  //上升
                  item.DeviceProgressEffect = 'top'
                } else if (item.DeviceProgressValue > (((value - min) / (max - min)).toFixed(2)) * 100) {
                  //下降
                  item.DeviceProgressEffect = 'bottom'
                } else {
                  //不变
                  item.DeviceProgressEffect = 'unset'
                }
                item.DeviceProgressValue = (((value - min) / (max - min)).toFixed(2)) * 100;
                item.DeviceProgress_state = state;
              }
            }

            /*管道或文本标签更新*/
            if (item.DevicePropCode && (this.common.istrue(items[item.DevicePropCode.split('-')[0]])||this.common.istrue(items[item.DevicePropCode.split('-')[0]])==0)) {
              if (this.common.istrue(item.DevicePropCode)) {
                // let feature = await self.getProductFeature(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                let feature;
                if(item.DeviceName!='虚拟设备'){
                  feature = await self.getProductFeature(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                }else{
                  feature = await self.getVirtualDevicePro(item.DevicePropCode.split('-')[1], item.DevicePropCode.split('-')[0]);
                  feature.dataType = {}
                }
                if (item.rotateDeg != 0||item.id == 11) {
                  /*管道*/
                  let value = Number(items[item.DevicePropCode.split('-')[0]])
                  let itemValue = Number(item.thresholdValue)
                  if (feature.dataType.type == 'bool' || feature.dataType.type == 'enum') {
                    if (item.thresholdSymbol == 0) {
                      if (Number(item.thresholdValue) == value) {
                        item.thresholdMark = true;
                      }
                    }
                  } else {
                    if (item.thresholdSymbol == 0) {
                      // >
                      if (value > itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 1) {
                      // >=
                      if (value >= itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 2) {
                      // ==
                      if (value == itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 3) {
                      // <
                      if (value < itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 4) {
                      // <=
                      if (value <= itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 5) {
                      // !=
                      if (value != itemValue) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 6) {
                      //in
                      let arr = JSON.parse(item.thresholdValue);
                      if (arr.filter(item => Number(item) == value).length != 0) {
                        item.thresholdMark = true;
                      }
                    } else if (item.thresholdSymbol == 7) {
                      //between
                      let arr = JSON.parse(item.thresholdValue);
                      if (Number(value) > Number(arr[0]) && Number(value) < Number(arr[1])) {
                        item.thresholdMark = true;
                      }
                    }
                  }
                } else if (item.type == 'span') {
                  if(item.DeviceName != '虚拟设备'){
                    /*文本标签*/
                    item.DevicePropName = feature.name;
                    item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], feature.dataType.type,
                      feature.dataType.specs.step);
                    item.DevicePropType = feature.dataType.type;
                    item.DevicePropUnit = feature.dataType.specs.unit;
                  }else{
                    /*文本标签*/
                    item.DevicePropValue = self.initValue(items[item.DevicePropCode.split('-')[0]], '',
                      feature.step);
                  }
                }
              }
            }
          } else if (topic.indexOf('/status/push') != -1) {

            /*报警提示灯更新*/
            if (this.common.istrue(JSON.stringify(data.alarm))) {
              if (item.propertie && item.propertie.hasAlarmLight && item.DeviceAlertLightShow) {
                /*1为正常 2为黄色 3为红色 先判断报警 后判断正常还是关机*/
                let state = 1;

                //判断是否当前为关机
                if (item.DeviceAlertLight_state == 0) {
                  state = 0
                }

                /*判断当前报警状态*/
                if (data.alarm.infor > 0 || data.alarm.warn > 0) {
                  state = 2;
                }
                if (data.alarm.error > 0) {
                  state = 3;
                }

                if (state == 1 || state == 0) {
                  let device = this.dataBlock.filter(dataBlock => dataBlock.code == item.DeviceCode).length != 0 ?
                    this.dataBlock.filter(dataBlock => dataBlock.code == item.DeviceCode)[0] : undefined
                  if (device) {
                    let attr = device.data.filter(block => block.id == item.DeviceAttrStateID).length != 0 ? device
                      .data.filter(block => block.id == item.DeviceAttrStateID)[0] : undefined;
                    if (attr) {
                      state = Number(attr.value)
                    }
                  }
                }

                item.DeviceAlertLight_state = state
              }

            }
            /*状态指示灯更新*/
            //						if(this.common.istrue(items._device_indicator)){
            //							/*设备状态*/
            //							if(item.type == 'watch' || item.type == 'value'){
            //								item.DeviceState = Number(items._device_indicator)
            //							}
            //
            //							/*指示灯状态*/
            //							if(item.propertie&&item.propertie.hasStateLight&&item.DeviceStateLightShow){
            //								if(items._device_indicator == 1){
            //									/* 先判断mqtt的指示灯状态(上限下限)值 如果无异常 则再判断开关机关联的属性(布尔值)是离线还是在线*/
            //									if(this.common.istrue(items[item.DeviceAttrStateID])){
            //										item.DeviceStateLight_state = items[item.DeviceAttrStateID];
            //									}
            //								}else{
            //									item.DeviceStateLight_state = items._device_indicator;
            //								}
            //							}
            //						}else if(item.propertie&&item.propertie.hasStateLight&&item.DeviceStateLightShow){
            //							/* 先判断mqtt的指示灯状态(上限下限)值 如果无异常 则再判断开关机关联的属性(布尔值)是离线还是在线*/
            //							if(this.common.istrue(items[item.DeviceAttrStateID])){
            //								item.DeviceStateLight_state = items[item.DeviceAttrStateID];
            //							}
            //						}
          }
        }
           this.$forceUpdate()
      },

      /*接收mqtt*/
      getMqttLightMessage() {
        // 接收消息处理
        this.$store.state.buerga.on('message', (topic, message) => {
          this.mqttUpdateFunction(topic, message)
        })

           this.$forceUpdate()

        //等待页面加载完毕后 截图 生成右下角小地图
        /*this.$nextTick(() => {
        	setTimeout(() =>{
        		this.screenShot()
        	},1000)
        })*/
      },

      /*截图*/
      screenShot() {
        let self = this;
        let x = 1345 * this.scaleLev.scaleX;
        let y = 838 * this.scaleLev.scaleY;

        /*方法二 使用dom-to-image*/
        domtoimage.toPng(self.$refs.father_draggable, {
          width: 1345,
          height: 838,
          cacheBust: true
        }).then((base64) => {
          //console.log(base64)
          self.$store.state.shotImg = base64

        }).catch((error) => {
          console.error('oops, something went wrong!', error);
        });
      },

      /*该方法用于更新组态地图中的Alt看板的数据*/
      mqttBynzkUpdata(topic, message) {
        let data = JSON.parse(message.toString());
        if (this.dataBlock.filter(item => item.code == data.deviceCode).length != 0) {
          for (let a of this.dataBlock.filter(item => item.code == data.deviceCode)[0].data) {
            if ((data.items[a.identifier] != undefined) && (data.items[a.identifier] != NaN) && (data.items[a
                .identifier] != null)) {
              //console.log(a)
              a.value = this.initValue(data.items[a.identifier], a.type, a.selectOptions.step)
            }
          }
          /*for(let item of this.draggable){
          	if(item.propertie&&item.propertie.hasAlarmLight&&item.DeviceAlertLightShow&&item.type=='img'&&item.DeviceCode){
          		if(this.common.istrue(item.DeviceAttrStateID)){
          			if((data.items[item.DeviceAttrStateID] != undefined) && (data.items[item.DeviceAttrStateID] != NaN) && (data.items[item.DeviceAttrStateID] != null)){
          				item.DeviceAlertLight_state = Number(data.items[item.DeviceAttrStateID])
          			}
          		}
          	}
          }*/
        }
        // 文本标签显示处理
        for(let obj of this.DeviceAttrList){
          if(obj.deviceCode == data.deviceCode){
            let arr = []
            Object.keys(data.items).forEach(function(key){     //将items转为键值对象
                let devObj ={};
                devObj.code = key;
                devObj.value = data.items[key];
                arr.push(devObj);
            });
            obj.attrValList = arr
          }
        }
        this.$forceUpdate();
      },

      /*接收mqtt*/
      getMqttMessage() {
        // 接收消息处理
        this.$store.state.nazeki.on('message', (topic, message) => {
          this.mqttBynzkUpdata(topic, message)
          this.$forceUpdate();
        })
      },

      /*判断值是否存在*/
      istrue(val) {
        this.common.istrue(val)
      },

      /*更新dataBlock*/
      UpdateDataBlock() {
				return new Promise(async (resolve) => {
					let arr = this.draggable.filter(item => item.type == 'img' && this.common.istrue(item.DeviceId) && item.DeviceName != "虚拟设备");
					await this.getDeviceList();
					let NewDataBlock = [];
					for(let obj of arr){
						let nowDevice = this.DeviceList.filter(item => item.id == obj.DeviceId)[0]?this.DeviceList.filter(item => item.id == obj.DeviceId)[0]:{}
						let _v = JSON.parse(JSON.stringify(nowDevice));
						_v.propertySet = _v.propertySet?_v.propertySet.split(','):[];
						if(NewDataBlock.filter(item => item.code == _v.code).length == 0){
							NewDataBlock.push(_v);
						}
					}
          for(let Device of NewDataBlock){
            Device.data = await this.getAttrPushDataBlock(Device);
          }
					//console.log(NewDataBlock)
					this.dataBlock = JSON.parse(JSON.stringify(NewDataBlock))

					// console.log(this.dataBlock);
					resolve();
				})
      },

      /*传入一个设备对象 返回设备下的布尔类型的属性与属性值 数组*/
      // wx_getAttrPushDataBlock(DeviceObj) {
      //   let self = this;
      //   return new Promise((resolve) => {
      //     /*获取设备属性列表*/
      //     self.wx_get('/Device/getPropertyValue', {
      //       deviceId: DeviceObj.id
      //     }).then(async (resAttr) => {
      //       if (resAttr.success == true) {
      //         //var valueList = resAttr.result;
      //         let dataList = await self.getProductFeature(DeviceObj.code)
      //         let attrList = DeviceObj.propertySet;
      //         let AttrArr = [];
      //         for (let attr of attrList) {
      //           for (let featureList of dataList) {
      //             if (featureList.identifier == attr) {
      //               let selectOptions = [];
      //               if (featureList.dataType.type == 'enum') {
      //                 Object.keys(featureList.dataType.specs).forEach(function(key) {
      //                   let devObj = {};
      //                   devObj.id = Number(key);
      //                   devObj.name = featureList.dataType.specs[key];
      //                   selectOptions.push(devObj);
      //                 });
      //               }
      //               let value = null;
      //               if (resAttr.result.length != 0) {
      //                 if (resAttr.result.filter(item => item.code == featureList.identifier).length != 0) {
      //                   value = resAttr.result.filter(item => item.code == featureList.identifier)[0].value
      //                 }
      //               }
      //               let obj = {
      //                 id: DeviceObj.id, //设备id
      //                 identifier: featureList.identifier, //标识符
      //                 DeviceCode: DeviceObj.code, //设备code
      //                 name: featureList.name, //属性名字
      //                 DeviceName: DeviceObj.name, //设备名字
      //                 unit: featureList.dataType.specs.unit, //单位
      //                 max: featureList.dataType.specs.max, //属性值可输入的最大值
      //                 min: featureList.dataType.specs.min, //属性值可输入的最小值
      //                 errorDown: featureList.dataType.errorDown, //属性值下限
      //                 errorUp: featureList.dataType.errorUp, //属性值上限
      //                 warnDown: featureList.dataType.warnDown, //属性值下下限
      //                 warnUp: featureList.dataType.warnUp, //属性值上上限
      //                 step: featureList.dataType.specs.step, //属性值的步长
      //                 type: featureList.dataType.type, //属性值的数据类型
      //                 accessMode: featureList.accessMode, //属性值的可读写状态 r rw
      //                 // value: self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step),//属性值
      //                 selectOptions: featureList.dataType.type == 'enum' ? selectOptions : featureList
      //                   .dataType.specs, //如果为枚举 布尔 赋值options
      //               }
      //               if (value || value == 0) {
      //                 obj.value = self.initValue(value, featureList.dataType.type, featureList.dataType.specs
      //                   .step)
      //               }
      //               AttrArr.push(obj)
      //             }
      //           }
      //         }
      //         resolve(AttrArr)
      //       } else {
      //         resolve([])
      //       }
      //     })
      //   })
      // },

      /*传入一个设备对象 返回设备下的布尔类型的属性与属性值 数组*/
      getAttrPushDataBlock(DeviceObj) {
        let self = this;
        return new Promise(async (resolve) => {
          /*获取设备属性列表*/
          let DeviceArr = self.DeviceAttrList.filter(item => item.deviceCode == DeviceObj.code)
          let dataList = await self.getProductFeature(DeviceObj.code)
          if(DeviceArr.length==0){
            self.get('/Device/getPropertyValue', {
              deviceId: DeviceObj.id
            }).then(async (resAttr) => {
              if (resAttr.success == true) {
                //var valueList = resAttr.result;
                /*获取对应设备的物模型*/
                let attrList = DeviceObj.propertySet;
                let AttrArr = [];
                for (let attr of attrList) {
                  for (let featureList of dataList) {
                    if (featureList.identifier == attr) {
                      let selectOptions = [];
                      if (featureList.dataType.type == 'enum') {
                        Object.keys(featureList.dataType.specs).forEach(function(key) {
                          let devObj = {};
                          devObj.id = Number(key);
                          devObj.name = featureList.dataType.specs[key];
                          selectOptions.push(devObj);
                        });
                      }
                      let value = null;
                      if (resAttr.result.length != 0) {
                        if (resAttr.result.filter(item => item.code == featureList.identifier).length != 0) {
                          value = resAttr.result.filter(item => item.code == featureList.identifier)[0].value
                        }
                      }
                      let obj = {
                        id: DeviceObj.id, //设备id
                        identifier: featureList.identifier, //标识符
                        DeviceCode: DeviceObj.code, //设备code
                        name: featureList.name, //属性名字
                        DeviceName: DeviceObj.name, //设备名字
                        unit: featureList.dataType.specs.unit, //单位
                        max: featureList.dataType.specs.max, //属性值可输入的最大值
                        min: featureList.dataType.specs.min, //属性值可输入的最小值
                        errorDown: featureList.dataType.errorDown, //属性值下限
                        errorUp: featureList.dataType.errorUp, //属性值上限
                        warnDown: featureList.dataType.warnDown, //属性值下下限
                        warnUp: featureList.dataType.warnUp, //属性值上上限
                        step: featureList.dataType.specs.step, //属性值的步长
                        type: featureList.dataType.type, //属性值的数据类型
                        accessMode: featureList.accessMode, //属性值的可读写状态 r rw
                        // value: self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step),//属性值
                        selectOptions: featureList.dataType.type == 'enum' ? selectOptions : featureList
                          .dataType.specs, //如果为枚举 布尔 赋值options
                      }
                      if (value || value == 0) {
                        obj.value = self.initValue(value, featureList.dataType.type, featureList.dataType.specs
                          .step)
                      }
                      AttrArr.push(obj)
                    }
                  }
                }
                resolve(AttrArr)
              } else {
                resolve([])
              }
            })
          }else{
            let valueList = DeviceArr[0].attrValList;
            /*获取对应设备的物模型*/
            let attrList = DeviceObj.propertySet;
            let AttrArr = [];
            for (let attr of attrList) {
              for (let featureList of dataList) {
                if (featureList.identifier == attr) {
                  let selectOptions = [];
                  if (featureList.dataType.type == 'enum') {
                    Object.keys(featureList.dataType.specs).forEach(function(key) {
                      let devObj = {};
                      devObj.id = Number(key);
                      devObj.name = featureList.dataType.specs[key];
                      selectOptions.push(devObj);
                    });
                  }
                  let value = null;
                  if (valueList.length != 0) {
                    if (valueList.filter(item => item.code == featureList.identifier).length != 0) {
                      value = valueList.filter(item => item.code == featureList.identifier)[0].value
                    }
                  }
                  let obj = {
                    id: DeviceObj.id, //设备id
                    identifier: featureList.identifier, //标识符
                    DeviceCode: DeviceObj.code, //设备code
                    name: featureList.name, //属性名字
                    DeviceName: DeviceObj.name, //设备名字
                    unit: featureList.dataType.specs.unit, //单位
                    max: featureList.dataType.specs.max, //属性值可输入的最大值
                    min: featureList.dataType.specs.min, //属性值可输入的最小值
                    errorDown: featureList.dataType.errorDown, //属性值下限
                    errorUp: featureList.dataType.errorUp, //属性值上限
                    warnDown: featureList.dataType.warnDown, //属性值下下限
                    warnUp: featureList.dataType.warnUp, //属性值上上限
                    step: featureList.dataType.specs.step, //属性值的步长
                    type: featureList.dataType.type, //属性值的数据类型
                    accessMode: featureList.accessMode, //属性值的可读写状态 r rw
                    // value: self.initValue(value,featureList.dataType.type,featureList.dataType.specs.step),//属性值
                    selectOptions: featureList.dataType.type == 'enum' ? selectOptions : featureList
                      .dataType.specs, //如果为枚举 布尔 赋值options
                  }
                  if (value || value == 0) {
                    obj.value = self.initValue(value, featureList.dataType.type, featureList.dataType.specs
                      .step)
                  }
                  AttrArr.push(obj)
                }
              }
            }
            resolve(AttrArr)
          }
        })
      },

      /*获取公司设备列表*/
      getDeviceList() {
        /* 同步
         * 返回空
         * */
        let self = this;
        return new Promise((resolve) => {
          if (this.DeviceList.length == 0) {
            this.get('/Device/getList', {
              companyId: this.companyId
            }).then((res) => {
              if (res.success == true) {
                this.DeviceList = res.result.filter(item => item.propertySet.split(',')[0] != '');
                this.get('/VirtualDevice/get', {
                  companyId: this.companyId
                }).then((res) => {
                  if (res.success == true) {
                    this.VirtualDevice = res.result
                    this.DeviceList.push(res.result);
                  }
                  resolve();
                })
              }
            })
            // if (this.type == 'mobile') {
            //   this.wx_get('/Device/getList', {
            //     companyId: this.companyId
            //   }).then((res) => {
            //     if (res.success == true) {
            //       this.DeviceList = res.result.filter(item => item.propertySet.split(',')[0] != '');
            //       this.wx_get('/VirtualDevice/get', {
            //         companyId: this.companyId
            //       }).then((res) => {
            //         if (res.success == true) {
            //           this.VirtualDevice = res.result
            //           this.DeviceList.push(res.result);
            //         }
            //         resolve();
            //       })
            //     }
            //   })
            // } else {
            //   this.get('/Device/getList', {
            //     companyId: this.companyId
            //   }).then((res) => {
            //     if (res.success == true) {
            //       this.DeviceList = res.result.filter(item => item.propertySet.split(',')[0] != '');
            //       this.get('/VirtualDevice/get', {
            //         companyId: this.companyId
            //       }).then((res) => {
            //         if (res.success == true) {
            //           this.VirtualDevice = res.result
            //           this.DeviceList.push(res.result);
            //         }
            //         resolve();
            //       })
            //     }
            //   })
            // }
          } else {
            resolve();
          }
        })
      },

      NearEndClassFun(item) {
        if (item.rotateDeg == 30) {
          return 'NearEnd30'
        } else if (item.rotateDeg == 90) {
          return 'NearEnd90'
        } else {
          return 'FarEnd30'
        }
      },
      FarEndClassFun(item) {
        if (item.rotateDeg == 30) {
          return 'FarEnd30'
        } else if (item.rotateDeg == 90) {
          return 'FarEnd90'
        } else {
          return 'NearEnd30'
        }
      },
      getOffsetTop(obj) {
        var tmp = obj.offsetTop;
        var val = obj.offsetParent;
        while (val != null) {
          tmp += val.offsetTop;
          val = val.offsetParent;
        }
        return tmp;
      },
      getOffsetLeft(obj) {
        var tmp = obj.offsetLeft;
        var val = obj.offsetParent;
        while (val != null) {
          tmp += val.offsetLeft;
          val = val.offsetParent;
        }
        return tmp;
      },
      mouseDown(event) {
        //				if(this.SpaceMark){
        var self = this;
        self.spaceShow = 'grabbing'
        var evt = window.event || arguments[0];
        var startX = (evt.x || evt.clientX);
        var startY = (evt.y || evt.clientY);
        var nowLeft = this.editorLeft;
        var nowTop = this.editorTop;
        const drag = () => {
          evt = window.event || arguments[0];
          let _x = (evt.x || evt.clientX),
            _y = (evt.y || evt.clientY);
          let x = ((_x - startX) / self.scaleLevel) / self.scaleLev.scaleX,
            y = ((_y - startY) / self.scaleLevel) / self.scaleLev.scaleY;
          self.editorLeft = nowLeft + x;
          self.editorTop = nowTop + y;
          if (self.$parent.$parent.newPointLeft) {
            self.$parent.$parent.newPointLeft(Math.ceil(((self.editorLeft * self.scaleLevel) * .2) - self.$parent
              .$parent.DelX))
            self.$parent.$parent.newPointTop(Math.ceil(((self.editorTop * self.scaleLevel) * .2) - self.$parent
              .$parent.DelY))
          }
        }
        const up = () => {
          if (self.spaceShow == 'grabbing') {
            self.spaceShow = 'grab'
          }
          document.removeEventListener('mousemove', drag);
          document.removeEventListener('mouseup', up);
        }
        document.addEventListener('mousemove', drag);
        document.addEventListener('mouseup', up);
        //				}
      },
      touchStart(event) {
        var self = this;
        var evt = window.event || arguments[0];
        // console.log('touchStart: ' + evt.touches.length);
        if (evt.touches.length == 2) {
          // console.log(evt.touches);
          var startXA = (evt.touches[0].changedTouches[0].x || evt.touches[0].changedTouches[0].clientX);
          var startYA = (evt.touches[0].changedTouches[0].y || evt.touches[0].changedTouches[0].clientY);
          var startXB = (evt.touches[1].changedTouches[0].x || evt.touches[1].changedTouches[0].clientX);
          var startYB = (evt.touches[1].changedTouches[0].y || evt.touches[1].changedTouches[0].clientY);
          var thisLength = Math.sqrt(Math.pow((startXB - startXA), 2) + Math.pow((startYB - startYA), 2))

          const drag = () => {
            evt = window.event || arguments[0];
            let _xA = (evt.touches[0].changedTouches[0].x || evt.touches[0].changedTouches[0].clientX),
              _yA = (evt.touches[0].changedTouches[0].y || evt.touches[0].changedTouches[0].clientY);

            let _xB = (evt.touches[1].changedTouches[1].x || evt.touches[1].changedTouches[1].clientX),
              _yB = (evt.touches[1].changedTouches[1].y || evt.touches[1].changedTouches[1].clientY);

            var thisLengthTwo = Math.sqrt(Math.pow((_xB - _xA), 2) + Math.pow((_yB - _yA), 2))
            if ((thisLengthTwo - thisLength) > 100) {
              if (this.slider.ValueNum == 25) {
                this.slider.ValueNum = 31.25;
              } else if (this.slider.ValueNum == 31.25) {
                this.slider.ValueNum = 50;
              } else if (this.slider.ValueNum == 50) {
                this.slider.ValueNum = 62.5;
              } else if (this.slider.ValueNum == 62.5) {
                this.slider.ValueNum = 100;
              }
            } else if ((thisLengthTwo - thisLength) < 100) {
              if (this.slider.ValueNum == 100 && this.scaleMaxValue <= 0.625) {
                this.slider.ValueNum = 62.5;
              } else if (this.slider.ValueNum == 62.5 && this.scaleMaxValue <= 0.5) {
                this.slider.ValueNum = 50;
              } else if (this.slider.ValueNum == 50 && this.scaleMaxValue <= 0.3125) {
                this.slider.ValueNum = 31.25;
              } else if (this.slider.ValueNum == 31.25 && this.scaleMaxValue <= 0.25) {
                this.slider.ValueNum = 25;
              }
            }
            // console.log('按下的距离','滑动的距离')
            // console.log(thisLength,thisLengthTwo)
            // console.log('左边滑动xy','右边滑动xy')
            // console.log(_xA,_yA,_xB,_yB)
          }
          const up = () => {
            document.removeEventListener('touchmove', drag);
            document.removeEventListener('touchend', up);
          }
          document.addEventListener('touchmove', drag);
          document.addEventListener('touchend', up);
        } else if (evt.touches.length == 1) {
          // console.log(evt.touches);
          var startX = (evt.changedTouches[0].x || evt.changedTouches[0].clientX);
          var startY = (evt.changedTouches[0].y || evt.changedTouches[0].clientY);
          var nowLeft = this.editorLeft;
          var nowTop = this.editorTop;
          const drag = () => {
            evt = window.event || arguments[0];
            let _x = (evt.changedTouches[0].x || evt.changedTouches[0].clientX),
              _y = (evt.changedTouches[0].y || evt.changedTouches[0].clientY);
            let x = (((_x - startX) / self.scaleLevel) / self.scaleLev.scaleX) * 2,
              y = (((_y - startY) / self.scaleLevel) / self.scaleLev.scaleY) * 2;
            self.editorLeft = nowLeft + x;
            self.editorTop = nowTop + y;
          }
          if(this.type != 'mobile'){
            const up = () => {
            	document.removeEventListener('touchmove',drag);
            	document.removeEventListener('touchend',up);
            }
            document.addEventListener('touchmove', drag);
            document.addEventListener('touchend', up);
          }

        }

      },
      touchend(event) {
        // console.log(event)
        this.startX = '';
        this.startY = '';
      },
      touchmove(event) {
        // console.log(event)
        let self = this;
        var evt = event || arguments[0];
        // console.log('touchmove',evt)
        if (evt.touches.length >= 1) {
          //单指
          if (this.startX == '') {
            //刚按下时
            this.startX = (evt.touches[0].clientX || evt.touches[0].x);
            this.startY = (evt.touches[0].clientY || evt.touches[0].y);
            this.nowLeft = this.editorLeft;
            this.nowTop = this.editorTop;
          } else {
            //已按住后的继续移动
            let _x = (evt.touches[0].clientX || evt.touches[0].x),
              _y = (evt.touches[0].clientY || evt.touches[0].y);

            let x = (((_x - this.startX) / self.scaleLevel) / self.scaleLev.scaleX),
              y = (((_y - this.startY) / self.scaleLevel) / self.scaleLev.scaleY);
            this.editorLeft = parseInt(this.nowLeft + x);
            this.editorTop = parseInt(this.nowTop + y);
            // console.log(this.nowLeft,this.nowTop,x,y,self.scaleLev.scaleY,self.scaleLev.scaleX)
          }
        }
      },
      rotateDegAngle(item) {
        if (item.rotateDeg == 90 || item.rotateDeg == 0) {
          return 0
        } else {
          return item.rotateDeg
        }
      },
      ...mapMutations("defaultImgOptions", {
        scaleLevelModify: 'scaleLevelModify',
        ClickShowMarkUpdata: 'ClickShowMarkUpdata',
        editorLeftUpdata: 'editorLeftUpdata',
        editorTopUpdata: 'editorTopUpdata'
      }),
      handleScroll(e) {
        e.stopPropagation();
        e.preventDefault();
        var direction = e.deltaY > 0 ? 'down' : 'up' //该语句可以用来判断滚轮是向上滑动还是向下
        if (direction == 'down') {
          if (this.slider.ValueNum == 100 && this.scaleMaxValue <= 0.625) {
            this.slider.ValueNum = 62.5;
          } else if (this.slider.ValueNum == 62.5 && this.scaleMaxValue <= 0.5) {
            this.slider.ValueNum = 50;
          } else if (this.slider.ValueNum == 50 && this.scaleMaxValue <= 0.3125) {
            this.slider.ValueNum = 31.25;
          } else if (this.slider.ValueNum == 31.25 && this.scaleMaxValue <= 0.25) {
            this.slider.ValueNum = 25;
          }
        } else if (direction == 'up') {
          if (this.slider.ValueNum == 25) {
            this.slider.ValueNum = 31.25;
          } else if (this.slider.ValueNum == 31.25) {
            this.slider.ValueNum = 50;
          } else if (this.slider.ValueNum == 50) {
            this.slider.ValueNum = 62.5;
          } else if (this.slider.ValueNum == 62.5) {
            this.slider.ValueNum = 100;
          }
        }
      },
      SkewAlingnmentDiv(rotateDeg) {
        if (rotateDeg != 90) {
          return {
            transform: `rotate(${-rotateDeg}deg)`,
          }
        }
      },

      backgroundDiv(imgurl, rotateDeg) {
        if (rotateDeg == 30 || rotateDeg == -30 || rotateDeg == 0) {
          return {
            backgroundImage: 'url(' + imgurl + ')',
            backgroundRepeat: 'repeat-x'
          }
        } else if (rotateDeg == 90) {
          return {
            backgroundImage: 'url(' + require('@/assets/image/editor/gray_top.png') + ')',
            backgroundRepeat: 'repeat-y',
            'transform-origin': '100% 100%',
          }
        }
      },
      ChangeClick(itemObj, type) {
        if (type != 'Editor' && itemObj.type == 'Divspan' && itemObj.DeviceMoth != null) {
          /*展示属性看板*/
          this.changeDivSpan(itemObj.index);
          this.$emit('attr', this.draggable.filter(item => item.index == itemObj.index)[0])

        } else if (type != 'Editor' && itemObj.type == 'img' && itemObj.DeviceId != null) {
          this.$emit('attr', this.draggable.filter(item => item.index == itemObj.index)[0])
        }
      },
      /*切换看板颜色*/
      changeDivSpan(index) {
        this.draggable.filter(item => item.index == index)[0].ClickShowMark = !this.draggable.filter(item => item
          .index == index)[0].ClickShowMark;
      },

    },
    watch: {
      /*editorLeft(val){
      	this.editorLeftUpdata(val);
      },
      editorTop(val){
      	this.editorTopUpdata(val);
      },*/
      SliderValue(val) {
        this.$refs.father_draggable.style.transform = 'scale(' + val / 100 + ')';
        this.scaleLevelModify(val / 100)
      },
      async AttrShow(val) {
        if (val) {
          let arr = this.draggable.filter(item => item.type == 'img' && this.common.istrue(item.DeviceId) && item
            .DeviceName != "虚拟设备");
          for (let a of arr) {
            a.AttrShow = true;
          }

        } else {
          let arr = this.draggable.filter(item => item.type == 'img' && this.common.istrue(item.DeviceId) && item
            .DeviceName != "虚拟设备");
          for (let a of arr) {
            a.AttrShow = false;
          }
          /*for(let url of this.MqttByDataSetUrl){
          	this.$store.state.nazeki.unsubscribe(url,this.MqttExitBackFunction)
          }
          this.MqttByDataSetUrl = [];*/
        }
      },
    },
  }
</script>
<style scoped>
  .zjtClass {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .darkDivSpan span {
    color: #57a7ff !important;
    background: rgba(12, 25, 42, .2) !important;
  }

  .UnPointer {
    cursor: not-allowed !important;
  }

  .ProgressBarShow>>>.ProgressTop .el-progress-bar__inner {
    background-image: url(../../../assets/image/editor/progresstop.png);
  }

  .ProgressBarShow>>>.ProgressBottom .el-progress-bar__inner {
    background-image: url(../../../assets/image/editor/progressbottom.png);
  }

  .ProgressBarShow>>>.ProgressUnset .el-progress-bar__inner {
    background-image: url(../../../assets/image/editor/progressH.png);
  }

  .ProgressBarShow>>>.blueBystate .el-progress-bar__inner {
    background-color: #2188DA !important;
    background-repeat: repeat-x;
    background-position: center;
    background-size: 10px 10px;
  }

  .ProgressBarShow>>>.yellowBystate .el-progress-bar__inner {
    background-color: #FBAD34 !important;
    background-repeat: repeat-x;
    background-position: center;
    background-size: 10px 10px;
  }

  .ProgressBarShow>>>.redBystate .el-progress-bar__inner {
    background-color: #F57A7A !important;
    background-repeat: repeat-x;
    background-position: center;
    background-size: 10px 10px;
  }

  .ProgressBarShow>>>.el-progress-bar__outer {
    background-color: #B9B9B9 !important;
  }

  .directionTwo {
    transform: rotate(180deg);
    top: 1px;
  }

  .XGif {
    transform: rotate(180deg);
    top: 1px;
  }

  .rotateDegGit {
    width: 100%;
    height: 100%;
    position: absolute;
    transform-origin: 50% 50%;

  }

  .MousePointer {
    cursor: pointer !important;
  }

  .rightList {
    position: absolute;
    width: 198px;
    background-color: #151515;
    color: #E6E6E6;
    font-size: 12px;
    border-radius: 1px;
    z-index: 999;
  }

  .rightList_box {
    float: left;
    text-indent: 18px;
    background-color: #353738;
    line-height: 36px;
    text-align: left;
    width: 100%;
    cursor: pointer;
  }

  .rightList_box:hover {
    background-color: #2571EF !important;

  }

  .tr-transform.Divspan {
    cursor: pointer;
  }

  .typeDivSpan {
    cursor: pointer;
  }

  .conduit_show {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: .7;
  }

  .typeImg {
    position: absolute;
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .repeatTop {
    background-repeat: repeat-y !important;
    background-size: 2.5px 42px !important;
    left: 2.5px !important;
  }

  .Conduit_gif {
    /*background-image: url(../../../assets/image/editor/gray_gif.gif);*/
    background-repeat: repeat-x;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 3px;
    opacity: .4;
    background-size: 42px 2.5px;
  }

  .typeImg .AlarmLightShow {
    position: absolute;
    background-position: center;
    width: 21px;
    height: 24px;
    background-size: 100%;
    background-repeat: no-repeat;
    /*background-image: url(../../../assets/image/editor/Device/green_error.png);*/
  }

  .typeImg .AlarmLightShow-1 {
    background-image: url(../../../assets/image/editor/Device/gray_error_system.png);
  }

  .typeImg .AlarmLightShow0 {
    background-image: url(../../../assets/image/editor/Device/gray_error.png);
  }

  .typeImg .AlarmLightShow1 {
    background-image: url(../../../assets/image/editor/Device/green_error.png);
  }

  .typeImg .AlarmLightShow2 {
    background-image: url(../../../assets/image/editor/Device/yellow_error.png);
  }

  .typeImg .AlarmLightShow3 {
    background-image: url(../../../assets/image/editor/Device/red_error.png);
  }



  .typeImg .StateLightShow {
    position: absolute;
    background-position: center;
    width: 13px;
    height: 10px;
    background-size: 100%;
    background-repeat: no-repeat;
    /*background-image: url(../../../assets/image/editor/Device/green_point.png);*/
  }

  .typeImg .StateLightShow0 {
    background-image: url(../../../assets/image/editor/Device/gray_point.png);
  }

  .typeImg .StateLightShow1 {
    background-image: url(../../../assets/image/editor/Device/green_point.png);
  }

  .typeImg .StateLightShow2 {
    background-image: url(../../../assets/image/editor/Device/yellow_point.png);
  }

  .typeImg .StateLightShow3 {
    background-image: url(../../../assets/image/editor/Device/red_point.png);
  }



  .typeImg .ProgressBarShow {
    position: absolute;
    background-position: center;
    width: 64px;
    height: 8px;
    background-size: 100%;
    background-repeat: no-repeat;
    transform: rotate(-90deg);
    /* background-image: url(../../../assets/image/editor/Device/green_progress.png); */
    transform-origin: 0 0;
    margin-top: 64px;
  }




  .typeWatch .LightShow {
    position: absolute;
    background-position: center;
    width: 13px;
    height: 10px;
    background-size: 100%;
    background-repeat: no-repeat;
    top: -2px;
    left: -2px;
  }

  .typeWatch .LightShow.state1 {
    background-image: url(../../../assets/image/editor/Device/green_point.png);
  }

  .typeWatch .LightShow.state2 {
    background-image: url(../../../assets/image/editor/Device/yellow_point.png);
  }

  .typeWatch .LightShow.state3 {
    background-image: url(../../../assets/image/editor/Device/red_point.png);
  }

  .typeWatch .LightShow.state0 {
    background-image: url(../../../assets/image/editor/Device/gray_point.png);
  }

  .typeValve .LightShow {
    position: absolute;
    background-position: center;
    width: 13px;
    height: 10px;
    background-size: 100%;
    background-repeat: no-repeat;
    top: -6px;
    left: -6px;
  }

  .typeValve .LightShow.state1 {
    background-image: url(../../../assets/image/editor/Device/green_point.png);
  }

  .typeValve .LightShow.state2 {
    background-image: url(../../../assets/image/editor/Device/yellow_point.png);
  }

  .typeValve .LightShow.state3 {
    background-image: url(../../../assets/image/editor/Device/red_point.png);
  }

  .typeValve .LightShow.state0 {
    background-image: url(../../../assets/image/editor/Device/gray_point.png);
  }

  .typeSpan {
    width: 100%;
    height: 100%;
    /*color: #f5f5f5;*/
    font-size: 23px;
    text-align: center;
    white-space: nowrap;
  }

  .mobile span {
    background: transparent !important;
    color: #2c3e50 !important;
  }

  .lightSpan span {
    background: rgba(213, 213, 213, 1);
    color: #636363;
    border-radius: 5px;
    padding: 13px 14px 11px 18px;
    letter-spacing: 1px;
  }

  .darkSpan span {
    background: rgba(12, 25, 42, .2);
    color: #FFFFFF;
    border-radius: 5px;
    padding: 13px 14px 11px 18px;
    letter-spacing: 1px;
  }

  .drag {
    /*height: 100%;
		width: 100%;*/
    height: 838px;
    width: 1345px;
    position: absolute;
    overflow: hidden;
    z-index: 1;
    /*top: 45px;
    	left: 45px;*/
  }

  .activeDraggable.conduit30>>>.tr-transform__scale-point--ml,
  .activeDraggable.conduit30>>>.tr-transform__scale-point--mr {
    display: block;
  }

  .activeDraggable.conduit-30>>>.tr-transform__scale-point--ml,
  .activeDraggable.conduit-30>>>.tr-transform__scale-point--mr {
    display: block;
  }

  .activeDraggable.conduit90>>>.tr-transform__scale-point--tm,
  .activeDraggable.conduit90>>>.tr-transform__scale-point--bm {
    display: block;
  }

  .tr-transform--active>>>.tr-transform__content {
    border: 0px !important;
  }

  .NearEnd30 {
    position: absolute;
    /*left: -20px;*/
    /*transform: rotate(-30deg);*/
    top: -10px;
  }

  .FarEnd30 {
    position: absolute;
    /*right: -25px;*/
    /*transform: rotate(-30deg);*/
    top: -8px;
  }

  .NearEnd90 {
    position: absolute;
    left: -9px;
    /*transform: rotate(-30deg);*/
    /*top: -10px;*/
  }

  .FarEnd90 {
    position: absolute;
    right: -11px;
    /*transform: rotate(-30deg);*/
    /*top: -8px;*/
  }

  .function {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 10;
  }

  .function_img {
    width: 25px;
    height: 20px;
    text-align: center;
  }

  .function .function_img img {
    width: 18px;
    height: 5px;
  }

  .function .function_box {
    position: absolute;
    float: left;
    width: 65px;
    white-space: nowrap;
    z-index: 1;
    background-color: #252f40;
    -webkit-box-shadow: 0 0.1vw 0.3vw 0 rgba(0, 0, 0, .3);
    box-shadow: 0 0.1vw 0.3vw 0 rgba(0, 0, 0, .3);
    color: #fff;
    margin-top: 4px;
    border-radius: 1px;
  }

  .function .function_box div {
    width: 100%;
    height: 27px;
    line-height: 25px;
    letter-spacing: 1px;
  }

  .function .function_box div:hover {
    background-color: #131721;
    color: #28b3fc;
  }

  .vdr .button:hover {
    background-color: #CA3A45;
    color: #fff;
  }

  .vdr .button {
    border: 1.5px solid #CA3A45;
    border-radius: 3px;
    color: #CA3A45;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: #fff;
    font-size: 15px;
    -webkit-transition: .1s;
    transition: .1s;
    position: relative;
    /* margin: 20px;*/
  }

  .vdr .button span {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: auto;
    height: 20px;
    min-width: 30px;
    text-align: center;
  }

  .positionInfo .count {
    font-size: 10px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: inline-block;
    width: auto;
    color: grey;
  }

  .positionInfo .x1,
  .positionInfo .x2 {
    position: absolute;
    top: -20px;
    left: 0;
    /*transform: scale(1.2) translateX(-100%);*/
    margin-left: 10px;
  }

  .positionInfo .y1,
  .positionInfo .y2 {
    position: absolute;
    top: 0;
    left: -20px;
    transform-origin: 100% -50%;
    /*transform: scale(1.2);*/
    margin-top: -8px;
  }

  .font {
    text-align: center;
    color: #fff;
  }

  .navigatorLine {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    box-sizing: content-box;
    /*display: none;*/
  }

  .navigatorLine .line {
    transform: scale(1);
  }

  .navigatorLine .topLine {
    position: absolute;
    z-index: 0;
    top: -.0625vw;
    left: -100vw;
    border-top: 1px dashed grey;
    width: 200vw;
    height: 0;
  }

  .navigatorLine .bottomLine {
    position: absolute;
    bottom: -.0625vw;
    border-top: 1px dashed grey;
    left: -100vw;
    width: 200vw;
    height: 0;
  }

  .navigatorLine .leftLine {
    position: absolute;
    left: -.0625vw;
    top: -100vh;
    border-left: 1px dashed grey;
    height: 250vh;
    width: 0;
  }

  .navigatorLine .rightLine {
    position: absolute;
    top: -100vh;
    right: -.0625vw;
    border-left: 1px dashed grey;
    height: 250vh;
    width: 0;
  }

  .SkewAlignment {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    box-sizing: content-box;
    z-index: 99;
  }

  .SkewAlignment .LeftTop {
    position: absolute;
    top: 50%;
    left: 50%;
    border-top: 0.5px solid #f0c;
    ;
    width: 150px;
    height: 0;
    transform: rotate(-30deg);
    transform-origin: left top;
  }

  .SkewAlignment .LeftBottom {
    position: absolute;
    bottom: 0px;
    border-top: 0.5px solid #f0c;
    left: 50%;
    right: 0;
    top: 50%;
    height: 0;
    width: 150px;
    -webkit-transform: rotate(-150deg);
    transform: rotate(-150deg);
    transform-origin: left top;
  }

  .SkewAlignment .RightTop {
    position: absolute;
    top: 1px;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(-150deg);
    transform-origin: right top;
  }

  .SkewAlignment .RightBottom {
    position: absolute;
    bottom: 0;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0px;
    transform: rotate(-30deg);
    transform-origin: right bottom;
  }

  .SkewAlignment .LeftTop_vm {
    position: absolute;
    top: 50%;
    left: 50%;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(-210deg);
    transform-origin: left top;
  }

  .SkewAlignment .LeftBottom_vm {
    position: absolute;
    bottom: 0;
    border-top: 0.5px solid #f0c;
    left: 50%;
    height: 0;
    top: 50%;
    right: 0;
    width: 150px;
    -webkit-transform: rotate(30deg);
    transform: rotate(30deg);
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }

  .SkewAlignment .RightTop_vm {
    position: absolute;
    top: 0vw;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(30deg);
    transform-origin: right top;
  }

  .SkewAlignment .RightBottom_vm {
    position: absolute;
    /* top: 0vw; */
    bottom: 0;
    right: 0;
    /* left: 0; */
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0px;
    transform: rotate(150deg);
    transform-origin: right bottom;
  }

  .Draggable-slider {
    position: absolute;
    bottom: 40px;
    right: 60px;
    width: 300px;
  }

  .Draggable-slider .box {
    width: 75px;
    float: left;
  }

  .Draggable-slider .box input {
    width: 100%;
  }

  .Draggable-slider .vue-slider.vue-slider-ltr {
    width: 200px !important;
    float: right !important;
  }

  .vue-slider-mark .vue-slider-mark-active {
    top: 100% !important;
  }

  .yoyoo-ddr.active {
    border: 0px !important;
    outline: 1px solid #607d8b !important;
  }

  .test {
    outline: 1px solid red !important;
  }

  .father_draggable {
    transform-origin: 50% 50%;
    width: 100%;
    height: 100%;
    position: absolute;
    background-position-x: 20px;
    z-index: 10;
    /*transition: .1s;*/
  }

  .draggable {
    position: absolute;
    /* transform-origin: 0px 0px; */
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    cursor: grab;
  }

  .seled1>>>.tr-transform__content {
    outline: rgb(96, 125, 139) solid 1px !important;
  }

  .seled2>>>.tr-transform__content {
    outline: rgb(96, 125, 139) solid 2px !important;
  }

  .seled3>>>.tr-transform__content {
    outline: rgb(96, 125, 139) solid 3px !important;
  }

  .seled4>>>.tr-transform__content {
    outline: rgb(96, 125, 139) solid 4px !important;
  }

  .seled5>>>.tr-transform__content {
    outline: rgb(96, 125, 139) solid 5px !important;
  }

  .father_draggable .draggable .handle.handle-tl {
    margin-top: -5px;
    margin-left: -5px;
    display: block;
    cursor: unset;
  }

  .draggable .conduit {
    width: 100%;
    height: 100%;
  }

  .backgroundDiv {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .conduit_show {
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: .7;
  }

  .typeDivSpan span {
    background: rgba(213, 213, 213, .5);
    border-radius: 5px;
    /*text-decoration: underline;*/
    color: #0461c7;
    font-size: 23px;
    padding: 13px 14px 11px 18px;
  }

  .typeDivSpan {
    width: 100%;
    height: 100%;
    /* color: #f5f5f5; */
    font-size: 18px;
    text-align: center;
    white-space: nowrap;
  }

  .typeValve,
  .typeWatch {
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .zIndexbottom {
    z-index: 5 !important;
    position: absolute;
    display: block;
    cursor: unset;
    margin-top: -5px;
    margin-left: -5px;
    width: 10px;
    height: 10px;
    background-color: #166dff;
    border-radius: 50%;
  }

  .SkewAlignmentEQ {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    box-sizing: content-box;
  }

  .SkewAlignmentEQ .LeftTop {
    position: absolute;
    top: -1px;
    left: 0vw;
    border-top: 0.5px solid #f0c;
    ;
    width: 150px;
    height: 0;
    transform: rotate(-30deg);
    transform-origin: left top;
  }

  .SkewAlignmentEQ .LeftBottom {
    position: absolute;
    bottom: -1px;
    border-top: 0.5px solid #f0c;
    left: 0;
    height: 0;
    width: 150px;
    transform: rotate(-150deg);
    transform-origin: left top;
  }

  .SkewAlignmentEQ .RightTop {
    position: absolute;
    top: 1px;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(-150deg);
    transform-origin: right top;
  }

  .SkewAlignmentEQ .RightBottom {
    position: absolute;
    bottom: 0;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0px;
    transform: rotate(-30deg);
    transform-origin: right bottom;
  }

  .SkewAlignmentEQ .LeftTop_vm {
    position: absolute;
    top: 0vw;
    left: 0vw;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(-210deg);
    transform-origin: left top;
  }

  .SkewAlignmentEQ .LeftBottom_vm {
    position: absolute;
    bottom: 0;
    border-top: 0.5px solid #f0c;
    left: 0;
    height: 0;
    width: 150px;
    transform: rotate(30deg);
    transform-origin: left top;
  }

  .SkewAlignmentEQ .RightTop_vm {
    position: absolute;
    top: 0vw;
    right: 0;
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0;
    transform: rotate(30deg);
    transform-origin: right top;
  }

  .SkewAlignmentEQ .RightBottom_vm {
    position: absolute;
    /* top: 0vw; */
    bottom: 0;
    right: 0;
    /* left: 0; */
    border-top: 0.5px solid #f0c;
    width: 150px;
    height: 0px;
    transform: rotate(150deg);
    transform-origin: right bottom;
  }

  .activeDraggable>>>.tr-transform--active {
    position: absolute;
  }

  .activeDraggable>>>.tr-transform__content {
    user-select: none;
  }

  .activeDraggable>>>.tr-transform__content .element {
    padding: 5px;
  }

  .activeDraggable>>>.tr-transform__rotator {
    top: -45px;
    left: calc(50% - 7px);
  }

  .activeDraggable>>>.tr-transform__rotator,
  .activeDraggable>>>.tr-transform__scale-point {
    background: #fff;
    width: 9px;
    height: 9px;
    z-index: 10;
    border-radius: 50%;
    position: absolute;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: none;
  }

  .activeDraggable>>>.tr-transform__rotator:hover,
  .activeDraggable>>>.tr-transform__scale-point:hover {
    background: #F1F5F8;
  }

  .activeDraggable>>>.tr-transform__rotator:active,
  .activeDraggable>>>.tr-transform__scale-point:active {
    background: #DAE1E7;
  }

  .activeDraggable>>>.tr-transform__scale-point {}

  .activeDraggable>>>.tr-transform__scale-point--tl {
    top: -7px;
    left: -7px;
  }

  .activeDraggable.conduit30>>>.tr-transform__scale-point--ml {
    top: calc(50% - 6px);
    left: -5px;
    cursor: nw-resize;
  }

  .activeDraggable.conduit-30>>>.tr-transform__scale-point--ml {
    top: calc(50% - 6px);
    left: -7px;
    cursor: ne-resize;
  }

  .activeDraggable>>>.tr-transform__scale-point--tr {
    left: calc(100% - 7px);
    top: -7px;
  }

  .activeDraggable>>>.tr-transform__scale-point--tm {
    left: calc(50% - 5px);
    top: -7px;
    cursor: n-resize;
  }

  .activeDraggable.conduit30>>>.tr-transform__scale-point--mr {
    left: calc(100% - 6px);
    top: calc(50% - 6px);
    cursor: nw-resize;
  }

  .activeDraggable.conduit-30>>>.tr-transform__scale-point--mr {
    left: calc(100% - 7px);
    top: calc(50% - 5px);
    cursor: ne-resize;
  }

  .activeDraggable>>>.tr-transform__scale-point--bl {
    left: -7px;
    top: calc(100% - 7px);
  }

  .activeDraggable>>>.tr-transform__scale-point--bm {
    left: calc(50% - 5px);
    top: calc(100% - 7px);
    cursor: s-resize;
  }

  .activeDraggable>>>.tr-transform__scale-point--br {
    left: calc(100% - 7px);
    top: calc(100% - 7px);
  }

  .gridbackground {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 0;
    /* transform: scale(1.75); */
  }

  .gridbackground.gridbackground-1 {
    background-image: url(../../../assets/image/editor/editorBg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .gridbackground.gridbackground-2 {
    background-image: url(../../../assets/image/editor/mapbg.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .gridbackground.gridbackground-3 {
    background-image: url(../../../assets/image/editor/mapbg2.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  /*.gridbackground.gridbackground-0625{
    	background: url(../../../assets/image/editor/0625.png)no-repeat center;
    }
    .gridbackground.gridbackground-05{
    	background: url(../../../assets/image/editor/05.png)no-repeat center;
    }
    .gridbackground.gridbackground-03125{
    	background: url(../../../assets/image/editor/03125.png)no-repeat center;
    }
    .gridbackground.gridbackground-025{
    	background: url(../../../assets/image/editor/025.png)no-repeat center;
    }*/

  .tr-transform>>>.tr-transform__controls {
    z-index: 50;
    /*outline: rgb(96, 125, 139) solid 1px !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/Preview/indexPreview.vue